import React, { useState, useEffect, useRef } from 'react'; //ai useRef
import { Tooltip, IconButton, Box } from '@mui/material';
import { useNavigate, useLocation, useSearchParams  } from 'react-router-dom';
import { UrlDev } from '../../url'; // ✅ Import your base URL
import { authFetch } from '../../utils/api'; // ✅ Import fetch wrapperL
import { alertC, confirmC } from '../../components/dialogService';
import MagicGlass from './MagicGlass';

import { useCrmSettings } from '../../CRM/SimpleCRM/CrmSettingsContext';
import { SCALE } from '../../constants';
import { CANVASW, CANVASH, INITX, INITY } from '../../constants';

import ExpandableSection from '../../expandablesection';
import '../../entrydoor.css'; // Import the CSS file for styles
import '../../toolbar.css';
import '../../spinner.css';
import '../../flip.css';

import { minmaxWindow } from '../../lib/minmax';
import { fetchUserField } from '../../utils/userSettings';

//--- Control Map Sections
import { getConfigurationSection } from './controlMaps/configurationSection';
import { getSizingAndFrameTopSection } from './controlMaps/sizingAndFrameTopSection';
import { getSizingAndFrameSection } from './controlMaps/sizingAndFrameSection';
import { getFinishSection } from './controlMaps/finishSection';
import { getGlassSection } from './controlMaps/glassSection';
import { getGrillsTopSection } from './controlMaps/grillsTopSection';
import { getGrillsSection } from './controlMaps/grillsSection';
import { getAdditionalItemsSection } from './controlMaps/additionalItemsSection';
import { getInstallationSection } from './controlMaps/installationSection';
import { getNotesSection } from './controlMaps/notesSection';
import { getDiscountsSection } from './controlMaps/discountsSection';
//---------
import { halfEllipsePerimeter, quarterEllipsePerimeter } from '../../utils/geometry';
import { USE_SHAPES, USE_SHAPES_TOP, DEFAULT_SHAPE } from '../../constants';
//---------

import { toPdf, toPdfAuto } from '../../components/toPdf';
import EmailDialog from '../../records/EmailDialog';
import { sendEmailWithPdf } from '../../components/sendEmailWithPdf';

import ViewDetails from '../../docs/viewdetails'; // Import sliding window
import { convertToImperial, formatToDecimal } from '../../controls/conversions';
import { formatToFractional } from '../../controls/conversions';
import { getCookie } from '../../utils/cookies';
import { get_crm_user_id } from '../../CRM/SimpleCRM/crmUtils';
import { authFetchRequest } from '../../utils/api';
import { getCustomerEmail } from '../../utils/QuickDataAccess';
import DrawWindow from '../../DrawWindow';
import { createCrmProduct, updateCrmProduct } from '../../CRM/ZohoCrm';

import SmallFloatingNavMenu from './components/SmallFloatingNavMenu';
import LargeFloatingNavMenu from './components/LargeFloatingNavMenu';
import TopBarNavMenu from './components/TopBarNavMenu';
import TopBarToolbarMenu from './components/TopBarToolbarMenu';
import SmallFloatingToolbarMenu from './components/SmallFloatingToolbarMenu';
import { useThemeColors } from '../../utils/useThemeColors';

const QUOTE_TEMPLATE = "w16_template";
const PRICE_RULES    = "w16_priceRules";
const ITEM_NAME      = 5;
const SECTIONS       = "5";
const DOCUMENT_TYPE  = "window";
const ITEM_PATH      = "windows/wint/w1";

const WW = ({config}) => {
    const { settings: crmSettings } = useCrmSettings();
    const crmDefined = crmSettings.external_crm !== 'none';
    const [sectionTopRowTitle, setSectionTopRowTitle] = useState("📐 Sizing & Frame - Top Row");
    const [showOriginalToolbar, setShowOriginalToolbar] = useState(false);
    const [showOnlySelectedSection, setShowOnlySelectedSection] = useState(false);
    const [enableFloatingNavMenu, setEnableFloatingNavMenu] = useState(true);
    const [enableFloatingToolbarMenu, setEnableFloatingToolbarMenu] = useState(true);
    const tc = useThemeColors();
    const [useSmallNavMenu, setUseSmallNavMenu] = useState(true);
    // Docked top-bar nav vs floating menu, driven by the user's navMenuStyle
    // preference (Home → Preferences). Top bar is the default; the legacy
    // floating menu only shows when the preference is explicitly 'floating'.
    const [showTopBar, setShowTopBar] = useState(true);
    const [selectedSectionId, setSelectedSectionId] = useState('Configuration');
    const [expandedSections, setExpandedSections] = useState({ 'Configuration': true });
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
   

    const [quoteId, setQuoteId]           = useState();
    const [quoteItemId, setQuoteItemId]   = useState();
    const [fkCustomerId, setFkCustomerId] = useState();
    const [fkUserId, setFkUserId]         = useState();
    const [viewItem, setViewItem]         = useState();
    const [reference_no, setReferenceNo]  = useState();
    //alert(quoteId + "," + quoteItemId+ "," +fkCustomerId+ "," +fkUserId+ "," + viewItem+ "," +reference_no)

  
    //const { quoteId, quoteItemId, fkCustomerId, fkUserId, viewItem, reference_no } = location.state || {};
    const [newQuoteItemId, setNewQuoteItemId] = useState(quoteItemId || null);
    const [lastDateSaved, setLastDateSaved] = useState("NA");
    const [isDisabled, setIsDisabled] = useState(false);

    const [doorData, setDoorData] = useState({});
    const [initialDoorDataJSON, setInitialDoorDataJSON] = useState(null); // Store initial state as JSON string
    const [isViewDetailsVisible, setIsViewDetailsVisible] = useState(false);
    const [viewDetailsData, setViewDetailsData] = useState([]);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [displayPrices, setDisplayPrices] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    //---------------
    const [topRowConfValue,    setTopRowConfValue]    = useState(config.WITH_UPPER_ONE_SECTION || "1");     // 1 Section
    const [topRowHeightValue,  setTopRowHeightValue]  = useState(config.TOP_ROW_HEIGHT || "20\"");          // 20"
    const [archLegHeightValue, setArchLegHeightValue] = useState(config.ARCH_LEG_HEIGHT || "0\"");          // 0"
    const [mainRowConfValue,   setMainRowConfValue]   = useState(config.WITH_MAIN_ROW_SECTIONS || "2");     // "1", "2"..."5"
    const [windowHeightValue,  setWindowHeightValue]  = useState(config.MAIN_ROW_HEIGHT || "50/");   
    const [totalWindowWidthValue,   setTotalWindowWidthValue]   = useState(config.MAIN_ROW_WIDTH  || "150/");       // 50"

    //Top row...
    const [windowTypeTopValue1,  setWindowTypeTopValue1]  = useState("None");
    const [windowTypeTopValue2,  setWindowTypeTopValue2]  = useState("None");
    const [windowTypeTopValue3,  setWindowTypeTopValue3]  = useState("None");
    const [windowTypeTopValue4,  setWindowTypeTopValue4]  = useState("None");
    const [windowTypeTopValue5,  setWindowTypeTopValue5]  = useState("None");

    const [windowShapeTopValue1,  setWindowShapeTopValue1]  = useState(DEFAULT_SHAPE);
    const [windowShapeTopValue2,  setWindowShapeTopValue2]  = useState(DEFAULT_SHAPE);
    const [windowShapeTopValue3,  setWindowShapeTopValue3]  = useState(DEFAULT_SHAPE);
    const [windowShapeTopValue4,  setWindowShapeTopValue4]  = useState(DEFAULT_SHAPE);
    const [windowShapeTopValue5,  setWindowShapeTopValue5]  = useState(DEFAULT_SHAPE);

    const [trapezoidTopLeftSizeValue1, setTrapezoidTopLeftSizeValue1] = useState("10\"");
    const [trapezoidTopLeftSizeValue2, setTrapezoidTopLeftSizeValue2] = useState("10\"");
    const [trapezoidTopLeftSizeValue3, setTrapezoidTopLeftSizeValue3] = useState("10\"");
    const [trapezoidTopLeftSizeValue4, setTrapezoidTopLeftSizeValue4] = useState("10\"");
    const [trapezoidTopLeftSizeValue5, setTrapezoidTopLeftSizeValue5] = useState("10\"");

    const [trapezoidTopRightSizeValue1, setTrapezoidTopRightSizeValue1] = useState("10\"");
    const [trapezoidTopRightSizeValue2, setTrapezoidTopRightSizeValue2] = useState("10\"");
    const [trapezoidTopRightSizeValue3, setTrapezoidTopRightSizeValue3] = useState("10\"");
    const [trapezoidTopRightSizeValue4, setTrapezoidTopRightSizeValue4] = useState("10\"");
    const [trapezoidTopRightSizeValue5, setTrapezoidTopRightSizeValue5] = useState("10\"");

    const [angledTopTrapezoidTopLeftSizeValue1, setAngledTopTrapezoidTopLeftSizeValue1] = useState("10\"");
    const [angledTopTrapezoidTopLeftSizeValue2, setAngledTopTrapezoidTopLeftSizeValue2] = useState("10\"");
    const [angledTopTrapezoidTopLeftSizeValue3, setAngledTopTrapezoidTopLeftSizeValue3] = useState("10\"");
    const [angledTopTrapezoidTopLeftSizeValue4, setAngledTopTrapezoidTopLeftSizeValue4] = useState("10\"");
    const [angledTopTrapezoidTopLeftSizeValue5, setAngledTopTrapezoidTopLeftSizeValue5] = useState("10\"");

    const [angledTopTrapezoidTopRightSizeValue1, setAngledTopTrapezoidTopRightSizeValue1] = useState("10\"");
    const [angledTopTrapezoidTopRightSizeValue2, setAngledTopTrapezoidTopRightSizeValue2] = useState("10\"");
    const [angledTopTrapezoidTopRightSizeValue3, setAngledTopTrapezoidTopRightSizeValue3] = useState("10\"");
    const [angledTopTrapezoidTopRightSizeValue4, setAngledTopTrapezoidTopRightSizeValue4] = useState("10\"");
    const [angledTopTrapezoidTopRightSizeValue5, setAngledTopTrapezoidTopRightSizeValue5] = useState("10\"");

    const [hingesTopValue1, setHingesTopValue1] = useState("Left");
    const [hingesTopValue2, setHingesTopValue2] = useState("Left");
    const [hingesTopValue3, setHingesTopValue3] = useState("Left");
    const [hingesTopValue4, setHingesTopValue4] = useState("Left");
    const [hingesTopValue5, setHingesTopValue5] = useState("Left");

    const [sliderTopValue1, setSliderTopValue1] = useState("Lift out");
    const [sliderTopValue2, setSliderTopValue2] = useState("Lift out");
    const [sliderTopValue3, setSliderTopValue3] = useState("Lift out");
    const [sliderTopValue4, setSliderTopValue4] = useState("Lift out");
    const [sliderTopValue5, setSliderTopValue5] = useState("Lift out");

    const [tiltAndTurnTopValue1, setTiltAndTurnTopValue1] = useState("Right Only");
    const [tiltAndTurnTopValue2, setTiltAndTurnTopValue2] = useState("Right Only");
    const [tiltAndTurnTopValue3, setTiltAndTurnTopValue3] = useState("Right Only");
    const [tiltAndTurnTopValue4, setTiltAndTurnTopValue4] = useState("Right Only");
    const [tiltAndTurnTopValue5, setTiltAndTurnTopValue5] = useState("Right Only");

    const [radiusxTopValue1, setRadiusxTopValue1] = useState(0);
    const [radiusxTopValue2, setRadiusxTopValue2] = useState(0);
    const [radiusxTopValue3, setRadiusxTopValue3] = useState(0);
    const [radiusxTopValue4, setRadiusxTopValue4] = useState(0);
    const [radiusxTopValue5, setRadiusxTopValue5] = useState(0);

    const [radiusyTopValue1, setRadiusyTopValue1] = useState(0);
    const [radiusyTopValue2, setRadiusyTopValue2] = useState(0);
    const [radiusyTopValue3, setRadiusyTopValue3] = useState(0);
    const [radiusyTopValue4, setRadiusyTopValue4] = useState(0);
    const [radiusyTopValue5, setRadiusyTopValue5] = useState(0);

    //Top row...^^^

    const [windowTypeValue1,  setWindowTypeValue1]  = useState("None");
    const [windowTypeValue2,  setWindowTypeValue2]  = useState("None");
    const [windowTypeValue3,  setWindowTypeValue3]  = useState("None");
    const [windowTypeValue4,  setWindowTypeValue4]  = useState("None");
    const [windowTypeValue5,  setWindowTypeValue5]  = useState("None");

    const [windowShapeValue1,  setWindowShapeValue1]  = useState(DEFAULT_SHAPE);
    const [windowShapeValue2,  setWindowShapeValue2]  = useState(DEFAULT_SHAPE);
    const [windowShapeValue3,  setWindowShapeValue3]  = useState(DEFAULT_SHAPE);
    const [windowShapeValue4,  setWindowShapeValue4]  = useState(DEFAULT_SHAPE);
    const [windowShapeValue5,  setWindowShapeValue5]  = useState(DEFAULT_SHAPE);

    const [trapezoidLeftSizeValue1, setTrapezoidLeftSizeValue1] = useState("10\"");
    const [trapezoidLeftSizeValue2, setTrapezoidLeftSizeValue2] = useState("10\"");
    const [trapezoidLeftSizeValue3, setTrapezoidLeftSizeValue3] = useState("10\"") ;
    const [trapezoidLeftSizeValue4, setTrapezoidLeftSizeValue4] = useState("10\"");
    const [trapezoidLeftSizeValue5, setTrapezoidLeftSizeValue5] = useState("10\"");

    const [trapezoidRightSizeValue1, setTrapezoidRightSizeValue1] = useState("10\"");
    const [trapezoidRightSizeValue2, setTrapezoidRightSizeValue2] = useState("10\"");
    const [trapezoidRightSizeValue3, setTrapezoidRightSizeValue3] = useState("10\"") ;
    const [trapezoidRightSizeValue4, setTrapezoidRightSizeValue4] = useState("10\"");
    const [trapezoidRightSizeValue5, setTrapezoidRightSizeValue5] = useState("10\"");

    const [angledTopTrapezoidLeftSizeValue1, setAngledTopTrapezoidLeftSizeValue1] = useState("10\"");
    const [angledTopTrapezoidLeftSizeValue2, setAngledTopTrapezoidLeftSizeValue2] = useState("10\"");
    const [angledTopTrapezoidLeftSizeValue3, setAngledTopTrapezoidLeftSizeValue3] = useState("10\"") ;
    const [angledTopTrapezoidLeftSizeValue4, setAngledTopTrapezoidLeftSizeValue4] = useState("10\"");
    const [angledTopTrapezoidLeftSizeValue5, setAngledTopTrapezoidLeftSizeValue5] = useState("10\"");

    const [angledTopTrapezoidRightSizeValue1, setAngledTopTrapezoidRightSizeValue1] = useState("10\"");
    const [angledTopTrapezoidRightSizeValue2, setAngledTopTrapezoidRightSizeValue2] = useState("10\"");
    const [angledTopTrapezoidRightSizeValue3, setAngledTopTrapezoidRightSizeValue3] = useState("10\"") ;
    const [angledTopTrapezoidRightSizeValue4, setAngledTopTrapezoidRightSizeValue4] = useState("10\"");
    const [angledTopTrapezoidRightSizeValue5, setAngledTopTrapezoidRightSizeValue5] = useState("10\"");

    const [windowWidthValue1, setWindowWidthValue1] = useState(config.MAIN_SECTION_WIDTH1 || "30\"");
    const [windowWidthValue2, setWindowWidthValue2] = useState(config.MAIN_SECTION_WIDTH2 || "30\"");
    const [windowWidthValue3, setWindowWidthValue3] = useState(config.MAIN_SECTION_WIDTH3 || "30\"") ;
    const [windowWidthValue4, setWindowWidthValue4] = useState(config.MAIN_SECTION_WIDTH4 || "30\"");
    const [windowWidthValue5, setWindowWidthValue5] = useState(config.MAIN_SECTION_WIDTH5 || "30\"");

    const [hingesValue1, setHingesValue1] = useState("Left");
    const [hingesValue2, setHingesValue2] = useState("Left");
    const [hingesValue3, setHingesValue3] = useState("Left");
    const [hingesValue4, setHingesValue4] = useState("Left");
    const [hingesValue5, setHingesValue5] = useState("Left");

    const [sliderValue1, setSliderValue1] = useState("Lift out");
    const [sliderValue2, setSliderValue2] = useState("Lift out");
    const [sliderValue3, setSliderValue3] = useState("Lift out");
    const [sliderValue4, setSliderValue4] = useState("Lift out");
    const [sliderValue5, setSliderValue5] = useState("Lift out");

    const [tiltAndTurnValue1, setTiltAndTurnValue1] = useState("Right Only");
    const [tiltAndTurnValue2, setTiltAndTurnValue2] = useState("Right Only");
    const [tiltAndTurnValue3, setTiltAndTurnValue3] = useState("Right Only");
    const [tiltAndTurnValue4, setTiltAndTurnValue4] = useState("Right Only");
    const [tiltAndTurnValue5, setTiltAndTurnValue5] = useState("Right Only");

    const [radiusxValue1, setRadiusxValue1] = useState(12);
    const [radiusxValue2, setRadiusxValue2] = useState(12);
    const [radiusxValue3, setRadiusxValue3] = useState(12);
    const [radiusxValue4, setRadiusxValue4] = useState(12);
    const [radiusxValue5, setRadiusxValue5] = useState(12);

    const [radiusyValue1, setRadiusyValue1] = useState(20);
    const [radiusyValue2, setRadiusyValue2] = useState(20);
    const [radiusyValue3, setRadiusyValue3] = useState(20);
    const [radiusyValue4, setRadiusyValue4] = useState(20);
    const [radiusyValue5, setRadiusyValue5] = useState(20);

    const [glassTypeValue1, setGlassTypeValue1] = useState({ value: "", label: "" });
    const [glassTypeValue2, setGlassTypeValue2] = useState({ value: "", label: "" });
    const [glassTypeValue3, setGlassTypeValue3] = useState({ value: "", label: "" });
    const [glassTypeValue4, setGlassTypeValue4] = useState({ value: "", label: "" });
    const [glassTypeValue5, setGlassTypeValue5] = useState({ value: "", label: "" });

    const [texturedDesignValue1,  setTexturedDesignValue1]  = useState({ value: "", label: "" });
    const [texturedDesignValue2,  setTexturedDesignValue2]  = useState({ value: "", label: "" });
    const [texturedDesignValue3,  setTexturedDesignValue3]  = useState({ value: "", label: "" });
    const [texturedDesignValue4,  setTexturedDesignValue4]  = useState({ value: "", label: "" });
    const [texturedDesignValue5,  setTexturedDesignValue5]  = useState({ value: "", label: "" });

    const [tintedDesignValue1,  setTintedDesignValue1]  = useState({ value: "", label: "" });
    const [tintedDesignValue2,  setTintedDesignValue2]  = useState({ value: "", label: "" });
    const [tintedDesignValue3,  setTintedDesignValue3]  = useState({ value: "", label: "" });
    const [tintedDesignValue4,  setTintedDesignValue4]  = useState({ value: "", label: "" });
    const [tintedDesignValue5,  setTintedDesignValue5]  = useState({ value: "", label: "" });

    const [glazingTypeValue1, setGlazingTypeValue1] = useState("Double");
    const [glazingTypeValue2, setGlazingTypeValue2] = useState("Double");
    const [glazingTypeValue3, setGlazingTypeValue3] = useState("Double");
    const [glazingTypeValue4, setGlazingTypeValue4] = useState("Double");
    const [glazingTypeValue5, setGlazingTypeValue5] = useState("Double");

    const [glassStrengthValue1, setGlassStrengthValue1] = useState({ value: "Annealed", label: "Annealed" }); 
    const [glassStrengthValue2, setGlassStrengthValue2] = useState({ value: "Annealed", label: "Annealed" });
    const [glassStrengthValue3, setGlassStrengthValue3] = useState({ value: "Annealed", label: "Annealed" });
    const [glassStrengthValue4, setGlassStrengthValue4] = useState({ value: "Annealed", label: "Annealed" });
    const [glassStrengthValue5, setGlassStrengthValue5] = useState({ value: "Annealed", label: "Annealed" });

    const [glassThicknessValue1, setGlassThicknessValue1] = useState("3mm");
    const [glassThicknessValue2, setGlassThicknessValue2] = useState("3mm");
    const [glassThicknessValue3, setGlassThicknessValue3] = useState("3mm");
    const [glassThicknessValue4, setGlassThicknessValue4] = useState("3mm");
    const [glassThicknessValue5, setGlassThicknessValue5] = useState("3mm");

    const [glassEnergyValue1, setGlassEnergyValue1] = useState({ value: "LowE 8071", label: "LowE 8071" }); 
    const [glassEnergyValue2, setGlassEnergyValue2] = useState({ value: "LowE 8071", label: "LowE 8071" }); 
    const [glassEnergyValue3, setGlassEnergyValue3] = useState({ value: "LowE 8071", label: "LowE 8071" }); 
    const [glassEnergyValue4, setGlassEnergyValue4] = useState({ value: "LowE 8071", label: "LowE 8071" }); 
    const [glassEnergyValue5, setGlassEnergyValue5] = useState({ value: "LowE 8071", label: "LowE 8071" }); 

    const [neatGlassValue1, setNeatGlassValue1] = useState("No");
    const [neatGlassValue2, setNeatGlassValue2] = useState("No");
    const [neatGlassValue3, setNeatGlassValue3] = useState("No");
    const [neatGlassValue4, setNeatGlassValue4] = useState("No");
    const [neatGlassValue5, setNeatGlassValue5] = useState("No");


    const [archGrillTypeValue1, setArchGrillTypeValue1] = useState({ value: "", label: "" });
    const [archGrillSizeValue1, setArchGrillSizeValue1] = useState('5/16"');
    const [archGrillPatternValue1, setArchGrillPatternValue1] = useState({ value: "", label: "" });
    const [archHorizontalGrillsValue1, setArchHorizontalGrillsValue1] = useState(0);
    const [archVerticalGrillsValue1, setArchVerticalGrillsValue1] = useState(0);

    const [archRaysGrillsValue1, setRaysGrillsValue1] = useState(3);

     /*top row grills setters starts...*/
    const [grillTypeTopValue1, setGrillTypeTopValue1] = useState({ value: "", label: "" });
    const [grillSizeTopValue1, setGrillSizeTopValue1] = useState('5/16"');
    const [grillPatternTopValue1, setGrillPatternTopValue1] = useState({ value: "", label: "" });
    const [horizontalGrillsTopValue1, setHorizontalGrillsTopValue1] = useState(1);
    const [verticalGrillsTopValue1, setVerticalGrillsTopValue1] = useState(1);

    const [grillTypeTopValue2, setGrillTypeTopValue2] = useState({ value: "", label: "" });
    const [grillSizeTopValue2, setGrillSizeTopValue2] = useState('5/16"');
    const [grillPatternTopValue2, setGrillPatternTopValue2] = useState({ value: "", label: "" });
    const [horizontalGrillsTopValue2, setHorizontalGrillsTopValue2] = useState(1);
    const [verticalGrillsTopValue2, setVerticalGrillsTopValue2] = useState(1);

    const [grillTypeTopValue3, setGrillTypeTopValue3] = useState({ value: "", label: "" });
    const [grillSizeTopValue3, setGrillSizeTopValue3] = useState('5/16"');
    const [grillPatternTopValue3, setGrillPatternTopValue3] = useState({ value: "", label: "" });
    const [horizontalGrillsTopValue3, setHorizontalGrillsTopValue3] = useState(1);
    const [verticalGrillsTopValue3, setVerticalGrillsTopValue3] = useState(1);

    const [grillTypeTopValue4, setGrillTypeTopValue4] = useState({ value: "", label: "" });
    const [grillSizeTopValue4, setGrillSizeTopValue4] = useState('5/16"');
    const [grillPatternTopValue4, setGrillPatternTopValue4] = useState({ value: "", label: "" });
    const [horizontalGrillsTopValue4, setHorizontalGrillsTopValue4] = useState(1);
    const [verticalGrillsTopValue4, setVerticalGrillsTopValue4] = useState(1);

    const [grillTypeTopValue5, setGrillTypeTopValue5] = useState({ value: "", label: "" });
    const [grillSizeTopValue5, setGrillSizeTopValue5] = useState('5/16"');
    const [grillPatternTopValue5, setGrillPatternTopValue5] = useState({ value: "", label: "" });
    const [horizontalGrillsTopValue5, setHorizontalGrillsTopValue5] = useState(1);
    const [verticalGrillsTopValue5, setVerticalGrillsTopValue5] = useState(1);  
    /*top row grills setters ends...*/

    const [grillTypeValue1, setGrillTypeValue1] = useState({ value: "", label: "" });
    const [grillSizeValue1, setGrillSizeValue1] = useState('5/16"');
    const [grillPatternValue1, setGrillPatternValue1] = useState({ value: "", label: "" });
    const [horizontalGrillsValue1, setHorizontalGrillsValue1] = useState(1);
    const [verticalGrillsValue1, setVerticalGrillsValue1] = useState(1);

    const [grillTypeValue2, setGrillTypeValue2] = useState({ value: "", label: "" });
    const [grillSizeValue2, setGrillSizeValue2] = useState('5/16"');
    const [grillPatternValue2, setGrillPatternValue2] = useState({ value: "", label: "" });
    const [horizontalGrillsValue2, setHorizontalGrillsValue2] = useState(1);
    const [verticalGrillsValue2, setVerticalGrillsValue2] = useState(1);


    const [grillTypeValue3, setGrillTypeValue3] = useState({ value: "", label: "" });
    const [grillSizeValue3, setGrillSizeValue3] = useState('5/16"');
    const [grillPatternValue3, setGrillPatternValue3] = useState({ value: "", label: "" });
    const [horizontalGrillsValue3, setHorizontalGrillsValue3] = useState(1);
    const [verticalGrillsValue3, setVerticalGrillsValue3] = useState(1);

    const [grillTypeValue4, setGrillTypeValue4] = useState({ value: "", label: "" });
    const [grillSizeValue4, setGrillSizeValue4] = useState('5/16"');
    const [grillPatternValue4, setGrillPatternValue4] = useState({ value: "", label: "" });
    const [horizontalGrillsValue4, setHorizontalGrillsValue4] = useState(1);
    const [verticalGrillsValue4, setVerticalGrillsValue4] = useState(1);

    const [grillTypeValue5, setGrillTypeValue5] = useState({ value: "", label: "" });
    const [grillSizeValue5, setGrillSizeValue5] = useState('5/16"');
    const [grillPatternValue5, setGrillPatternValue5] = useState({ value: "", label: "" });
    const [horizontalGrillsValue5, setHorizontalGrillsValue5] = useState(1);
    const [verticalGrillsValue5, setVerticalGrillsValue5] = useState(1);

    const [grillsInteriorColorValue,  setGrillsInteriorColorValue]  = useState({ value: "White", label: "White" });
    const [grillsExteriorColorValue,  setGrillsExteriorColorValue]  = useState({ value: "White", label: "White" });

    const [exteriorColorValue, setExteriorColorValue]  = useState({ value: "White", label: "White" });
    const [interiorColorValue, setInteriorColorValue]  = useState({ value: "White", label: "White" });
    const [colorFinishingValue, setColorFinishingValue] = useState();

    const [installationTypeValue, setInstallationTypeValue] = useState({ value: "None", label: "None" });
    const [exteriorTypeValue, setExteriorTypeValue] = useState({ value: "None", label: "None" });
    const [brickmoldSizeValue, setBrickmoldSizeValue] = useState({ value: "None", label: "None" });
    const [brickmoldColorValue,  setBrickmoldColorValue]  = useState({ value: "#FFFFFF", label: "White" });
    const [jambTypeValue, setJambTypeValue] = useState({ value: "None", label: "None" });
    const [interiorCasingValue, setInteriorCasingValue] = useState({ value: "None", label: "None" });
    const [interiorCasingSizeValue, setInteriorCasingSizeValue] = useState({ value: "", label: "" });
    const [frameDepthValue, setFrameDepthValue] = useState({ value: "", label: "" });

    const [locationTagValue, setLocationTagValue] = useState("");
    const [notesValue, setNotesValue]             = useState("");

    const [quantityValue, setQuantityValue] = useState("");
    const [discountValue, setDiscountValue] = useState(0);

    const [minmaxW, setMinMaxW] = useState({ minW: 0, maxW: 60, minH: 0, maxH: 100, maxSq: 0 });

    const requiredKeys = ["CascadingCombo1", "CascadingCombo2", "CascadingCombo3", "CascadingCombo4", "CascadingCombo5"];
    const [CascadingComboValue,  setCascadingComboValue]   = useState([]);
    const [CascadingComboValue1, setCascadingComboValue1]  = useState();
    const [CascadingComboValue2, setCascadingComboValue2]  = useState();
    const [CascadingComboValue3, setCascadingComboValue3]  = useState();
    const [CascadingComboValue4, setCascadingComboValue4]  = useState();
    const [CascadingComboValue5, setCascadingComboValue5]  = useState();
    //--------------- CRM start
    const [crm_product_id, set_crm_product_id]  = useState();

    //--------------- CRM end
    //email dialog
    const [showEmailDialog, setShowEmailDialog] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const [customerEmail, setCustomerEmail] = useState("");
    const [showAltToolbar, setShowAltToolbar] = useState(false);
    const [zoom, setZoom] = useState(1.00);

    const [flipped, setFlipped] = useState(false); // 👈 Flip state
    const [crmUserId, setCrmUserId] = useState(false); 
    const [ctrl_discount_enabled, set_ctrl_discount_enabled] = useState(0);

    useEffect(() => {
      const init = async () => {
        {

        }
        const id = await get_crm_user_id();
        setCrmUserId(id);

        const ctrl_discount_status = await fetchUserField('ctrl_discount_enabled');
        set_ctrl_discount_enabled(ctrl_discount_status);

        const navMenuPref = await fetchUserField('enableFloatingNavMenu');
        setEnableFloatingNavMenu(navMenuPref ?? true);
        const toolbarMenuPref = await fetchUserField('enableFloatingToolbarMenu');
        setEnableFloatingToolbarMenu(toolbarMenuPref ?? true);
        const navStylePref = await fetchUserField('navMenuStyle');
        setShowTopBar(navStylePref !== 'floating');

        const crmProductId = searchParams.get("id") || "NA"; // Assuming it's crm_product_id
        let inputData = await authFetch(`/local/get-ww-input-data/${crmProductId}`);
    
        if (inputData?.quoteItemId) {
          setQuoteId(inputData.quoteId);
          setQuoteItemId(inputData.quoteItemId);
          setFkCustomerId(inputData.fkCustomerId);
          setFkUserId(inputData.fkUserId);
          setReferenceNo(inputData.reference_no);
        } else if (location.state) {
          const {
            quoteId, quoteItemId, fkCustomerId,
            fkUserId, viewItem, reference_no
          } = location.state;
          
          setQuoteId(quoteId);
          setQuoteItemId(quoteItemId);
          setFkCustomerId(fkCustomerId);
          setViewItem(viewItem);
          setFkUserId(fkUserId);
          setReferenceNo(reference_no);
        }

        // When opened from "Add Predefined ... from My Library" the picker
        // navigates here with the template's full doorData in location.state.
        // No quoteItemId is set, so Save will create a fresh ItemQuote and
        // closing without saving creates nothing. We mirror the existing
        // edit-item path (setDoorData + setFormData + open the View Details
        // panel) so all sub-state setters propagate the template data.
        if (location.state?.libraryDoorData) {
          const tplDoorData = location.state.libraryDoorData;
          setDoorData(tplDoorData);
          setFormData(tplDoorData);
          setIsViewDetailsVisible(true);
        }
      };

      init();
    }, []);
    
    useEffect(() => {
      const loadEmail = async () => {
        const email = await getCustomerEmail(fkCustomerId);
        setCustomerEmail(email || "no customer email found");
      };
    
      if (fkCustomerId) {
        loadEmail();
      }
    }, [fkCustomerId]); 

    const handleFlipToggle = () => {
      setFlipped(prev => !prev);
    };

    const handleZoomIn = async () => {
      setZoom(prev => Math.min(prev + 0.05, 2)); // max zoom
    };
    const handleZoomOut = async () => {
      setZoom(prev => Math.max(prev - 0.05, 0.2)); // min zoom
    };
    const handleSendEmail = async (recipient) => {
        setShowEmailDialog(true); 
      };
    
    const handlePdfDownload = async () => {
        setIsLoading(true);
        try {
          // toPdfAuto picks server-side (Playwright) vs legacy (html2canvas)
          // based on USE_PDF_SERVER in constants.js. One switch flips the
          // whole app between vector and raster output.
          await toPdfAuto({
            container: ".view-details",
            filename: `${doorData?.frameData?.selectedDoor?.name || doorData?.frameData?.name || "No name available"}`,
          });
        } finally {
          setIsLoading(false);
        }
    };

    const handleSaveQuote = async (bSaveAndBack = false) => {
      try {
        // If bSaveAndBack is true, check if data changed
        if (bSaveAndBack) {
          // Check if data has changed OR if it's a new window (quoteItemId is not a number)
          if (hasDataChanged || !Number.isInteger(Number(quoteItemId))) {
            // Data has changed or new window, ask user
            const userChoice = await confirmC("Do you want to save before exiting?");
            if (!userChoice) {
              // User chose not to save, just exit
              navigate('/quotes', {
                state: {
                  quoteId: quoteId,
                  quoteItemId: quoteItemId
                }
              });
              return;
            }
            // User chose to save, continue with save logic
          } else {
            // No changes, just exit without asking
            navigate('/quotes', {
              state: {
                quoteId: quoteId,
                quoteItemId: quoteItemId
              }
            });
            return;
          }
        }

        const userId    = getCookie('user_id');

        if (parseInt(userId) !== parseInt(fkUserId)){
         await alertC("this quote item doesn't belong to you, you can't modify and save it.")
         //alert("userId:" + parseInt(userId) + ", fkUserId:" + parseInt(fkUserId));
          if (bSaveAndBack) {
            navigate('/quotes', {
              state: {
                quoteId: quoteId,           // ID of the parent quote
                quoteItemId: quoteItemId    // ID of the updated item (optional)
              }
            });
          }
          return;
        }
        const date = new Date();
        const formattedDate = date.toLocaleDateString('en-US', {
          year: '2-digit', 
          month: '2-digit', 
          day: '2-digit'
        });
        setLastDateSaved(formattedDate); //put the new last date...
        doorData.document.orderDate = formattedDate;
          
        if (!quoteId && !quoteItemId) {
          await alertC('create new Quote and NEW item')
        }
        if (quoteId && !quoteItemId && !newQuoteItemId) {//('Save NEW item in existing Quote')
          const payload = {
            fkQuoteId: quoteId,
            doorData: doorData,
            itemType: ITEM_PATH, //"window" - old one, wrong 
          };
          const itemRow = await authFetchRequest(
                            `/itemquotes/`,
                            payload,
                            "POST",
                            { Authorization: `Bearer ${getCookie("access_token")}` }
                        );
                        setNewQuoteItemId(itemRow?.id);

           if (crmDefined && (crmUserId !== "NA")) {
              const product_id = await createCrmProduct({
                quoteId, itemRow, doorData,
                authHeaders: { Authorization: `Bearer ${getCookie("access_token")}` }
              });
              if (product_id) set_crm_product_id(product_id);
           }
        }//^^^
        if ((quoteId && quoteItemId) || (quoteId && newQuoteItemId)) { //Quote & ItemQuote exist, just re-save
            const payload = {
              fkQuoteId: quoteId,
              doorData: doorData
            };
            const currentQuoteItemId = quoteItemId || newQuoteItemId;
            const itemRow = await authFetchRequest(
                              `/itemquotes/${currentQuoteItemId}`,
                              payload,
                              "PUT",
                              { Authorization: `Bearer ${getCookie("access_token")}` }
                          );
            if (crmDefined && (crmUserId !== "NA")) {
              await updateCrmProduct({
                quoteId, itemRow, doorData, crm_product_id,
                authHeaders: { Authorization: `Bearer ${getCookie("access_token")}` }
              });
            }
        }

        if (bSaveAndBack) {
            navigate('/quotes', {
              state: {
                quoteId: quoteId,           // ID of the parent quote
                quoteItemId: quoteItemId    // ID of the updated item (optional)
              }
            });
        }
        return;
  
      } catch (err) {
        console.error("❌ Failed to save quote and item quote:", err);
        alert("Failed to save.");
      }
    };
    const toggleViewDetails = () => {
        setIsViewDetailsVisible((prev) => !prev); // Toggle window
    };
    const togglePrices = () => {
        setDisplayPrices(!displayPrices);
    };

    useEffect(() => {
      if (viewItem === 'readonly'){
        setIsDisabled(true);
        setDisplayPrices(true);
      }
      const fetchData = async () => {
        try {
          if (!quoteId || !quoteItemId) {
            console.warn("❌ Missing quoteId or quoteItemId—skipping fetch.");
            return;
          }
    
          //console.log(`🔍 Fetching data from: ${UrlDev}/itemquotes/${quoteItemId}`);
          const data = await authFetch(`/itemquotes/${quoteItemId}`);
          //console.log("✅ API Response Data:", JSON.stringify(data, null, 2));
    
          if (!data?.doorData) {
            console.warn("❌ No valid doorData found.");
            alert("No valid doorData found.");
            return;
          }
    
          // Set the doorData state
          setDoorData(data.doorData);
    
          // Check if `selectedDoor` exists in `frameData`
          const selectedDoorItem = data.doorData?.frameData?.selectedDoor;
    
//          if (selectedDoorItem) {
            console.log("✅ Selected door detected:", selectedDoorItem.name);
            
            // Update item selector via ref
//            if (itemSelectorRef.current) {
//              itemSelectorRef.current.setSelectedItem(selectedDoorItem.name);
//            }
    
            if (crmDefined){
              set_crm_product_id(data?.crm_product_id || null);
            }
            setFormData(data.doorData); // Populate form
            setIsViewDetailsVisible(true);
//          }
    
          setHasLoaded(true); // Mark as loaded
    
        } catch (error) {
          console.error("❌ Fetch error:", error);
          alert(`Error: ${error.message}`);
        }
      };
    
      fetchData();
    }, [quoteId, quoteItemId]); // Runs when these values change

    // Function to map doorData to state setters
    const setFormData = (doorData) => {
      ///Main bbb
      setQuantityValue(doorData?.frameData?.quantity || "1");
      setDiscountValue(doorData?.discounts?.discount || "0");

      setTopRowConfValue(doorData?.frameData?.topRowConf || "None");
      setMainRowConfValue(doorData?.frameData?.nSections || 1);//SECTIONS;

      setArchLegHeightValue(doorData?.frameData?.archLegHeight || 0);
      setTopRowHeightValue(doorData?.frameData?.uHeight || "20\"");

      setWindowHeightValue(doorData?.frameData?.windowHeight || "50\"");
      
      setWindowTypeValue1(doorData?.frameData?.type1 || "None");
      setWindowTypeValue2(doorData?.frameData?.type2 || "None");
      setWindowTypeValue3(doorData?.frameData?.type3 || "None");
      setWindowTypeValue4(doorData?.frameData?.type4 || "None");
      setWindowTypeValue5(doorData?.frameData?.type5 || "None");

      if (USE_SHAPES) {
        setWindowShapeValue1(doorData?.frameData?.shape1 || DEFAULT_SHAPE);
        setWindowShapeValue2(doorData?.frameData?.shape2 || DEFAULT_SHAPE);
        setWindowShapeValue3(doorData?.frameData?.shape3 || DEFAULT_SHAPE);
        setWindowShapeValue4(doorData?.frameData?.shape4 || DEFAULT_SHAPE);
        setWindowShapeValue5(doorData?.frameData?.shape5 || DEFAULT_SHAPE);
      }
      setTrapezoidLeftSizeValue1(doorData?.frameData?.trapezoid1?.leftSize || "10\"");
      setTrapezoidLeftSizeValue2(doorData?.frameData?.trapezoid2?.leftSize || "10\"");
      setTrapezoidLeftSizeValue3(doorData?.frameData?.trapezoid3?.leftSize || "10\"");
      setTrapezoidLeftSizeValue4(doorData?.frameData?.trapezoid4?.leftSize || "10\"");
      setTrapezoidLeftSizeValue5(doorData?.frameData?.trapezoid5?.leftSize || "10\"");

      setTrapezoidRightSizeValue1(doorData?.frameData?.trapezoid1?.rightSize || "10\"");
      setTrapezoidRightSizeValue2(doorData?.frameData?.trapezoid2?.rightSize || "10\"");
      setTrapezoidRightSizeValue3(doorData?.frameData?.trapezoid3?.rightSize || "10\"");
      setTrapezoidRightSizeValue4(doorData?.frameData?.trapezoid4?.rightSize || "10\"");
      setTrapezoidRightSizeValue5(doorData?.frameData?.trapezoid5?.rightSize || "10\"");

      setAngledTopTrapezoidLeftSizeValue1(doorData?.frameData?.angledTopTrapezoid1?.leftSize || "10\"");
      setAngledTopTrapezoidLeftSizeValue2(doorData?.frameData?.angledTopTrapezoid2?.leftSize || "10\"");
      setAngledTopTrapezoidLeftSizeValue3(doorData?.frameData?.angledTopTrapezoid3?.leftSize || "10\"");
      setAngledTopTrapezoidLeftSizeValue4(doorData?.frameData?.angledTopTrapezoid4?.leftSize || "10\"");
      setAngledTopTrapezoidLeftSizeValue5(doorData?.frameData?.angledTopTrapezoid5?.leftSize || "10\"");

      setAngledTopTrapezoidRightSizeValue1(doorData?.frameData?.angledTopTrapezoid1?.rightSize || "10\"");
      setAngledTopTrapezoidRightSizeValue2(doorData?.frameData?.angledTopTrapezoid2?.rightSize || "10\"");
      setAngledTopTrapezoidRightSizeValue3(doorData?.frameData?.angledTopTrapezoid3?.rightSize || "10\"");
      setAngledTopTrapezoidRightSizeValue4(doorData?.frameData?.angledTopTrapezoid4?.rightSize || "10\"");
      setAngledTopTrapezoidRightSizeValue5(doorData?.frameData?.angledTopTrapezoid5?.rightSize || "10\"");


      setWindowWidthValue1(doorData?.frameData?.windowWidth1 || config.MAIN_SECTION_WIDTH1);
      setWindowWidthValue2(doorData?.frameData?.windowWidth2 || config.MAIN_SECTION_WIDTH2);
      setWindowWidthValue3(doorData?.frameData?.windowWidth3 || config.MAIN_SECTION_WIDTH3);
      setWindowWidthValue4(doorData?.frameData?.windowWidth4 || config.MAIN_SECTION_WIDTH4);
      setWindowWidthValue5(doorData?.frameData?.windowWidth5 || config.MAIN_SECTION_WIDTH5);

      setHingesValue1(doorData?.frameData?.hinges1 || "Left"); 
      setHingesValue2(doorData?.frameData?.hinges2 || "Left"); 
      setHingesValue3(doorData?.frameData?.hinges3 || "Left"); 
      setHingesValue4(doorData?.frameData?.hinges4 || "Left"); 
      setHingesValue5(doorData?.frameData?.hinges5 || "Left"); 

      setSliderValue1(doorData?.frameData?.slider1 || "Lift out");
      setSliderValue2(doorData?.frameData?.slider2 || "Lift out");
      setSliderValue3(doorData?.frameData?.slider3 || "Lift out");
      setSliderValue4(doorData?.frameData?.slider4 || "Lift out");
      setSliderValue5(doorData?.frameData?.slider5 || "Lift out");

      setTiltAndTurnValue1(doorData?.frameData?.tiltAndTurn1 || "Right Only");
      setTiltAndTurnValue2(doorData?.frameData?.tiltAndTurn2 || "Right Only");
      setTiltAndTurnValue3(doorData?.frameData?.tiltAndTurn3 || "Right Only");
      setTiltAndTurnValue4(doorData?.frameData?.tiltAndTurn4 || "Right Only");
      setTiltAndTurnValue5(doorData?.frameData?.tiltAndTurn5 || "Right Only"); 

      setRadiusxValue1(doorData?.frameData?.radiusx1 || 0);
      setRadiusxValue2(doorData?.frameData?.radiusx2 || 0);
      setRadiusxValue3(doorData?.frameData?.radiusx3 || 0);
      setRadiusxValue4(doorData?.frameData?.radiusx4 || 0);
      setRadiusxValue5(doorData?.frameData?.radiusx5 || 0);

      setRadiusyValue1(doorData?.frameData?.radiusy1 || 0);
      setRadiusyValue2(doorData?.frameData?.radiusy2 || 0);
      setRadiusyValue3(doorData?.frameData?.radiusy3 || 0);
      setRadiusyValue4(doorData?.frameData?.radiusy4 || 0);
      setRadiusyValue5(doorData?.frameData?.radiusy5 || 0);

      //Top...
      setWindowTypeTopValue1(doorData?.frameData?.typeTop1 || "None");
      setWindowTypeTopValue2(doorData?.frameData?.typeTop2 || "None");
      setWindowTypeTopValue3(doorData?.frameData?.typeTop3 || "None");
      setWindowTypeTopValue4(doorData?.frameData?.typeTop4 || "None");
      setWindowTypeTopValue5(doorData?.frameData?.typeTop5 || "None");

      if (USE_SHAPES_TOP) {
        setWindowShapeTopValue1(doorData?.frameData?.shapeTop1 || DEFAULT_SHAPE);
        setWindowShapeTopValue2(doorData?.frameData?.shapeTop2 || DEFAULT_SHAPE);
        setWindowShapeTopValue3(doorData?.frameData?.shapeTop3 || DEFAULT_SHAPE);
        setWindowShapeTopValue4(doorData?.frameData?.shapeTop4 || DEFAULT_SHAPE);
        setWindowShapeTopValue5(doorData?.frameData?.shapeTop5 || DEFAULT_SHAPE);
      }
      setTrapezoidTopLeftSizeValue1(doorData?.frameData?.trapezoidTop1?.leftSize || "10\"");
      setTrapezoidTopLeftSizeValue2(doorData?.frameData?.trapezoidTop2?.leftSize || "10\"");
      setTrapezoidTopLeftSizeValue3(doorData?.frameData?.trapezoidTop3?.leftSize || "10\"");
      setTrapezoidTopLeftSizeValue4(doorData?.frameData?.trapezoidTop4?.leftSize || "10\"");
      setTrapezoidTopLeftSizeValue5(doorData?.frameData?.trapezoidTop5?.leftSize || "10\"");

      setTrapezoidTopRightSizeValue1(doorData?.frameData?.trapezoidTop1?.rightSize || "10\"");
      setTrapezoidTopRightSizeValue2(doorData?.frameData?.trapezoidTop2?.rightSize || "10\"");
      setTrapezoidTopRightSizeValue3(doorData?.frameData?.trapezoidTop3?.rightSize || "10\"");
      setTrapezoidTopRightSizeValue4(doorData?.frameData?.trapezoidTop4?.rightSize || "10\"");
      setTrapezoidTopRightSizeValue5(doorData?.frameData?.trapezoidTop5?.rightSize || "10\"");

      setAngledTopTrapezoidTopLeftSizeValue1(doorData?.frameData?.angledTopTrapezoidTop1?.leftSize || "10\"");
      setAngledTopTrapezoidTopLeftSizeValue2(doorData?.frameData?.angledTopTrapezoidTop2?.leftSize || "10\"");
      setAngledTopTrapezoidTopLeftSizeValue3(doorData?.frameData?.angledTopTrapezoidTop3?.leftSize || "10\"");
      setAngledTopTrapezoidTopLeftSizeValue4(doorData?.frameData?.angledTopTrapezoidTop4?.leftSize || "10\"");
      setAngledTopTrapezoidTopLeftSizeValue5(doorData?.frameData?.angledTopTrapezoidTop5?.leftSize || "10\"");

      setAngledTopTrapezoidTopRightSizeValue1(doorData?.frameData?.angledTopTrapezoidTop1?.rightSize || "10\"");
      setAngledTopTrapezoidTopRightSizeValue2(doorData?.frameData?.angledTopTrapezoidTop2?.rightSize || "10\"");
      setAngledTopTrapezoidTopRightSizeValue3(doorData?.frameData?.angledTopTrapezoidTop3?.rightSize || "10\"");
      setAngledTopTrapezoidTopRightSizeValue4(doorData?.frameData?.angledTopTrapezoidTop4?.rightSize || "10\"");
      setAngledTopTrapezoidTopRightSizeValue5(doorData?.frameData?.angledTopTrapezoidTop5?.rightSize || "10\"");

      setHingesTopValue1(doorData?.frameData?.hingesTop1 || "Left"); 
      setHingesTopValue2(doorData?.frameData?.hingesTop2 || "Left"); 
      setHingesTopValue3(doorData?.frameData?.hingesTop3 || "Left"); 
      setHingesTopValue4(doorData?.frameData?.hingesTop4 || "Left"); 
      setHingesTopValue5(doorData?.frameData?.hingesTop5 || "Left"); 

      setSliderTopValue1(doorData?.frameData?.sliderTop1 || "Lift out");
      setSliderTopValue2(doorData?.frameData?.sliderTop2 || "Lift out");
      setSliderTopValue3(doorData?.frameData?.sliderTop3 || "Lift out");
      setSliderTopValue4(doorData?.frameData?.sliderTop4 || "Lift out");
      setSliderTopValue5(doorData?.frameData?.sliderTop5 || "Lift out");
      
      setTiltAndTurnTopValue1(doorData?.frameData?.tiltAndTurnTop1 || "Right Only");
      setTiltAndTurnTopValue2(doorData?.frameData?.tiltAndTurnTop2 || "Right Only");
      setTiltAndTurnTopValue3(doorData?.frameData?.tiltAndTurnTop3 || "Right Only");
      setTiltAndTurnTopValue4(doorData?.frameData?.tiltAndTurnTop4 || "Right Only");
      setTiltAndTurnTopValue5(doorData?.frameData?.tiltAndTurnTop5 || "Right Only"); 

      setRadiusxTopValue1(doorData?.frameData?.radiusxTop1 || 0);
      setRadiusxTopValue2(doorData?.frameData?.radiusxTop2 || 0);
      setRadiusxTopValue3(doorData?.frameData?.radiusxTop3 || 0);
      setRadiusxTopValue4(doorData?.frameData?.radiusxTop4 || 0);
      setRadiusxTopValue5(doorData?.frameData?.radiusxTop5 || 0);

      setRadiusyTopValue1(doorData?.frameData?.radiusyTop1 || 0);
      setRadiusyTopValue2(doorData?.frameData?.radiusyTop2 || 0);
      setRadiusyTopValue3(doorData?.frameData?.radiusyTop3 || 0);
      setRadiusyTopValue4(doorData?.frameData?.radiusyTop4 || 0);
      setRadiusyTopValue5(doorData?.frameData?.radiusyTop5 || 0);

      //Glass...
      setGlassTypeValue1(doorData?.glass?.glassType1);
      setGlassTypeValue2(doorData?.glass?.glassType1);
      setGlassTypeValue3(doorData?.glass?.glassType1);
      setGlassTypeValue4(doorData?.glass?.glassType1);
      setGlassTypeValue5(doorData?.glass?.glassType1);

      setTexturedDesignValue1(doorData?.glass?.texturedDesign1  || 'Frosted');
      setTexturedDesignValue2(doorData?.glass?.texturedDesign1  || 'Frosted');
      setTexturedDesignValue3(doorData?.glass?.texturedDesign1  || 'Frosted');
      setTexturedDesignValue4(doorData?.glass?.texturedDesign1  || 'Frosted');
      setTexturedDesignValue5(doorData?.glass?.texturedDesign1  || 'Frosted');

      setTintedDesignValue1(doorData?.glass?.tintedDesign1  || 'Grey');
      setTintedDesignValue2(doorData?.glass?.tintedDesign1  || 'Grey');
      setTintedDesignValue3(doorData?.glass?.tintedDesign1  || 'Grey');
      setTintedDesignValue4(doorData?.glass?.tintedDesign1  || 'Grey');
      setTintedDesignValue5(doorData?.glass?.tintedDesign1  || 'Grey');
    
      setGlazingTypeValue1(doorData?.glass?.glazingType1 || "Double");
      setGlassEnergyValue1(doorData?.glass?.glassEnergy1 || "LowE 8071");
      setNeatGlassValue1(doorData?.glass?.neatGlass1 || "No");
      setGlassStrengthValue1(doorData?.glass?.glassStrength1 || "Annealed");
      setGlassThicknessValue1(doorData?.glass?.glassThickness1 || "3mm");

      //grills arch ...
      setArchGrillTypeValue1(doorData?.grills?.archGrillType);
      setArchGrillSizeValue1(doorData?.grills?.archGrillSize ||'5/16"');
      setArchGrillPatternValue1(doorData?.grills?.archGrillPattern || "Colonial");
      setArchHorizontalGrillsValue1(doorData?.grills?.archHorizontalGrills || 0);
      setArchVerticalGrillsValue1(doorData?.grills?.archVerticalGrills || 0);
      setRaysGrillsValue1(doorData?.grills?.archRaysGrills || 3);
      //grills top...
      setGrillTypeTopValue1(doorData?.grills?.grillTypeTop1 || "None");
      setGrillSizeTopValue1(doorData?.grills?.grillsSizeTop1 ||'5/16"');
      setGrillPatternTopValue1(doorData?.grills?.grillsPatternTop1 || "Colonial");
      setHorizontalGrillsTopValue1(doorData?.grills?.glassDividersHorizontalTop1 || 1);
      setVerticalGrillsTopValue1(doorData?.grills?.glassDividersVerticalTop1 || 1);
      
      setGrillTypeTopValue2(doorData?.grills?.grillTypeTop2 || "None");
      setGrillSizeTopValue2(doorData?.grills?.grillsSizeTop2 ||'5/16"');
      setGrillPatternTopValue2(doorData?.grills?.grillsPatternTop2 || "Colonial");
      setHorizontalGrillsTopValue2(doorData?.grills?.glassDividersHorizontalTop2 || 1);
      setVerticalGrillsTopValue2(doorData?.grills?.glassDividersVerticalTop2 || 1);

      setGrillTypeTopValue3(doorData?.grills?.grillTypeTop3 || "None");
      setGrillSizeTopValue3(doorData?.grills?.grillsSizeTop3 ||'5/16"');
      setGrillPatternTopValue3(doorData?.grills?.grillsPatternTop3 || "Colonial");
      setHorizontalGrillsTopValue3(doorData?.grills?.glassDividersHorizontalTop3 || 1);
      setVerticalGrillsTopValue3(doorData?.grills?.glassDividersVerticalTop3 || 1);

      setGrillTypeTopValue4(doorData?.grills?.grillTypeTop4 || "None");
      setGrillSizeTopValue4(doorData?.grills?.grillsSizeTop4 ||'5/16"');
      setGrillPatternTopValue4(doorData?.grills?.grillsPatternTop4 || "Colonial");
      setHorizontalGrillsTopValue4(doorData?.grills?.glassDividersHorizontalTop4 || 1);
      setVerticalGrillsTopValue4(doorData?.grills?.glassDividersVerticalTop4 || 1);

      setGrillTypeTopValue5(doorData?.grills?.grillTypeTop5 || "None");
      setGrillSizeTopValue5(doorData?.grills?.grillsSizeTop5 ||'5/16"');
      setGrillPatternTopValue5(doorData?.grills?.grillsPatternTop5 || "Colonial");
      setHorizontalGrillsTopValue5(doorData?.grills?.glassDividersHorizontalTop5 || 1);
      setVerticalGrillsTopValue5(doorData?.grills?.glassDividersVerticalTop5 || 1);
      //grills main...
      setGrillTypeValue1(doorData?.grills?.grillType1);
      setGrillSizeValue1(doorData?.grills?.grillsSize1 ||'5/16"');
      setGrillPatternValue1(doorData?.grills?.grillsPattern1 || "Colonial");
      setHorizontalGrillsValue1(doorData?.grills?.glassDividersHorizontal1 || 1);
      setVerticalGrillsValue1(doorData?.grills?.glassDividersVertical1 || 1);

      setGrillTypeValue2(doorData?.grills?.grillType2);
      setGrillSizeValue2(doorData?.grills?.grillsSize2 ||'5/16"');
      setGrillPatternValue2(doorData?.grills?.grillsPattern2 || "Colonial");
      setHorizontalGrillsValue2(doorData?.grills?.glassDividersHorizontal2 || 1);
      setVerticalGrillsValue2(doorData?.grills?.glassDividersVertical2 || 1);

      setGrillTypeValue3(doorData?.grills?.grillType3);
      setGrillSizeValue3(doorData?.grills?.grillsSize3 ||'5/16"');
      setGrillPatternValue3(doorData?.grills?.grillsPattern3 || "Colonial");
      setHorizontalGrillsValue3(doorData?.grills?.glassDividersHorizontal3 || 1);
      setVerticalGrillsValue3(doorData?.grills?.glassDividersVertical3 || 1);

      setGrillTypeValue4(doorData?.grills?.grillType4);
      setGrillSizeValue4(doorData?.grills?.grillsSize4 ||'5/16"');
      setGrillPatternValue4(doorData?.grills?.grillsPattern4 || "Colonial");
      setHorizontalGrillsValue4(doorData?.grills?.glassDividersHorizontal4 || 1);
      setVerticalGrillsValue4(doorData?.grills?.glassDividersVertical4 || 1);

      setGrillTypeValue5(doorData?.grills?.grillType5);
      setGrillSizeValue5(doorData?.grills?.grillsSize5 ||'5/16"');
      setGrillPatternValue5(doorData?.grills?.grillsPattern5 || "Colonial");
      setHorizontalGrillsValue5(doorData?.grills?.glassDividersHorizontal5 || 1);
      setVerticalGrillsValue5(doorData?.grills?.glassDividersVertical5 || 1);

      //finish...
      setGrillsExteriorColorValue(doorData?.grills?.exteriorFinish || { value: "white", label: "white" });
      setGrillsInteriorColorValue(doorData?.grills?.interiorFinish || { value: "white", label: "white" });
      setInteriorColorValue(doorData?.finish?.interiorColor || { value: "White", label: "White" });
      setExteriorColorValue(doorData?.finish?.exteriorColor || { value: "White", label: "White" });
      setColorFinishingValue(doorData?.finish?.colorFinishing || "None");

      //installation...
      setInstallationTypeValue(doorData?.installation?.installationType || { value: "None", label: "None" });
      setExteriorTypeValue(doorData?.installation?.exteriorType || { value: "None", label: "None" });
      setBrickmoldSizeValue(doorData?.installation?.brickmoldSize || { value: "None", label: "None" });
      setBrickmoldColorValue(doorData?.installation?.brickmoldColor || { value: "#FFFFFF", label: "White" });
      setJambTypeValue(doorData?.installation?.jambType || { value: "None", label: "None" });
      setInteriorCasingValue(doorData?.installation?.interiorCasing || { value: "None", label: "None" });
      setInteriorCasingSizeValue(doorData?.installation?.interiorCasingSize || { value: "", label: "" });
      setFrameDepthValue(doorData?.installation?.frameDepth || { value: "", label: "" });

    
      //location/notes...
      setLocationTagValue(doorData?.notes?.LocationTag || null);
      setNotesValue(doorData?.notes?.notes || null);

      if (doorData?.additionalItems !== undefined){
        setCascadingComboValue1(doorData?.additionalItems?.CascadingCombo1 || "NA");
        setCascadingComboValue2(doorData?.additionalItems?.CascadingCombo2 || "NA");
        setCascadingComboValue3(doorData?.additionalItems?.CascadingCombo3 || "NA");
        setCascadingComboValue4(doorData?.additionalItems?.CascadingCombo4 || "NA");
        setCascadingComboValue5(doorData?.additionalItems?.CascadingCombo5 || "NA");
        //alert(JSON.stringify(doorData.additionalItems, null, 2));
        const convertedCombos = Object.entries(doorData?.additionalItems)
              .filter(([_, val]) => val !== "NA")
              .map(([id, value]) => ({ id, value }));
        setCascadingComboValue(convertedCombos);
      }
      const date = new Date();
      const formattedDate = date.toLocaleDateString('en-US', {
        year: '2-digit', 
        month: '2-digit', 
        day: '2-digit'
      });
      setLastDateSaved(doorData?.document?.orderDate || date);
    }//setFormData

    useEffect(() => {
      setCascadingComboValue1(CascadingComboValue[0]?.value || "NA");
      setCascadingComboValue2(CascadingComboValue[1]?.value || "NA");
      setCascadingComboValue3(CascadingComboValue[2]?.value || "NA");
      setCascadingComboValue4(CascadingComboValue[3]?.value || "NA");
      setCascadingComboValue5(CascadingComboValue[4]?.value || "NA");
    }, [CascadingComboValue]); // ✅ Ensures state updates when cascadingComboValue changes

    // Auto-switch topRowConfValue to "None" when non-Rectangle shapes are present
    useEffect(() => {
      const windowTypeValues = [windowTypeValue1, windowTypeValue2, windowTypeValue3, windowTypeValue4, windowTypeValue5];
      const windowShapeValues = [windowShapeValue1, windowShapeValue2, windowShapeValue3, windowShapeValue4, windowShapeValue5];

      let hasNonRectangleShapes = false;
      for (let i = 0; i < mainRowConfValue; i++) {
        if (windowTypeValues[i] === 'Picture') {
          const shape = windowShapeValues[i];
          if (shape && shape !== DEFAULT_SHAPE && shape !== 'None') {
            hasNonRectangleShapes = true;
            break;
          }
        }
      }

      // If non-Rectangle shapes exist and topRowConfValue is not "None", switch to "None"
      if (hasNonRectangleShapes && topRowConfValue !== 'None') {
        setTopRowConfValue('None');
        setProperTopRowSectionTitle('None');
      }
    }, [windowShapeValue1, windowShapeValue2, windowShapeValue3, windowShapeValue4, windowShapeValue5,
        windowTypeValue1, windowTypeValue2, windowTypeValue3, windowTypeValue4, windowTypeValue5,
        mainRowConfValue, topRowConfValue]); // Monitor shape and type changes

    const setProperTopRowSectionTitle = (newValue) => {
      if (newValue === "1") {
        setSectionTopRowTitle("📐 Sizing & Frame - Top Row - " + "(1 Section)");
      }
      if (newValue === "Grid") {
        setSectionTopRowTitle("📐 Sizing & Frame - Top Row - " + "(Grid)");
      }
      if (['ArchBar', 'Arch'].includes(newValue)) {
        setSectionTopRowTitle("📐 Sizing & Frame - Top Row - " + "(Arch)");
      }
    };
    const calcSquaresRectsOnly = () => {
      let [totalWidth, totalHeight, totalWidth_real, totalHeight_real] = [0, 0, 0, 0];
      const activeSections = parseInt(mainRowConfValue) || 0;
      
      for (let i = 1; i <= activeSections; i++) {
        const key = `windowWidth${i}_d`;
        const value = Number(doorData?.frameData?.[key]) || 0;
        totalWidth += value;

        const key_real = `windowWidth${i}_d_real`;
        const value_real = Number(doorData?.frameData?.[key_real]) || 0;
        totalWidth_real += value_real;
        console.log(`[calcSquares] Section ${i}: ${key_real} = ${doorData?.frameData?.[key_real]}, value_real = ${value_real}, totalWidth_real = ${totalWidth_real}`);
      }
      totalWidth = totalWidth/SCALE;
      totalWidth_real = totalWidth_real;

      console.log(`[calcSquares] FINAL: totalWidth = ${totalWidth}, totalWidth_real = ${totalWidth_real}`);

      doorData.frameData.mainRowHeight_d = doorData?.frameData?.windowHeight_d/SCALE || 0;
      doorData.frameData.mainRowHeight_d_real = parseFloat(doorData?.frameData?.windowHeight_d_real) || 0;
      doorData.frameData.mainRowWidth_d = totalWidth;
      doorData.frameData.mainRowWidth_d_real = totalWidth_real;

      console.log(`[calcSquares] SET: mainRowWidth_d = ${doorData.frameData.mainRowWidth_d}, mainRowWidth_d_real = ${doorData.frameData.mainRowWidth_d_real}`);
      doorData.frameData.mainRowWidth = formatToFractional(totalWidth);
      doorData.frameData.mainRowHeight = formatToFractional(doorData?.frameData?.mainRowHeight_d);

      
      if (topRowConfValue !== "None"){
        //calculate main Row
      }
      if (topRowConfValue === "None"){
          doorData.frameData.uHeight = 0;
          doorData.frameData.uHeight_d = 0;
          doorData.frameData.uHeight_d_real = 0;
      }
      //total square:
      doorData.frameData.totalSquare = (parseFloat(doorData?.frameData?.mainRowHeight_d_real || 0) + parseFloat(doorData?.frameData?.uHeight_d_real || 0)) *
                                        parseFloat(doorData?.frameData?.mainRowWidth_d_real || 0)/144;   

      if (['1', 'Arch', 'ArchBar'].includes(topRowConfValue)){

      }
    }//calcSquaresRectsOnly
    const calcSquares = () => {
      let [totalWidth, totalWidth_real] = [0, 0];
      const activeSections = parseInt(mainRowConfValue) || 0;
      let totalMainSquare = 0;
      let totalTopSquare = 0;

      // Main row height
      const mainRowHeight = parseFloat(doorData?.frameData?.windowHeight_d_real) || 0;
      // Top row height
      const topRowHeight = parseFloat(doorData?.frameData?.topRowHeight_d_real) || 0;

      // Calculate squares for sections 1-5 (main row and top row)
      for (let i = 1; i <= 5; i++) {
        const width = parseFloat(doorData?.frameData?.[`windowWidth${i}_d_real`]) || 0;

        // Main row square (rectangle only: width * height / 144)
        if (i <= activeSections && width > 0 && mainRowHeight > 0) {
          const squareVal = (width * mainRowHeight) / 144;
          doorData.frameData[`square${i}`] = squareVal.toFixed(2);
          totalMainSquare += squareVal;
        } else {
          doorData.frameData[`square${i}`] = "0.00";
        }

        // Top row square (rectangle only: width * height / 144)
        if (i <= activeSections && topRowConfValue !== "None" && width > 0 && topRowHeight > 0) {
          const topSquareVal = (width * topRowHeight) / 144;
          doorData.frameData[`topsquare${i}`] = topSquareVal.toFixed(2);
          totalTopSquare += topSquareVal;
        } else {
          doorData.frameData[`topsquare${i}`] = "0.00";
        }

        // Accumulate total width for active sections
        if (i <= activeSections) {
          const key = `windowWidth${i}_d`;
          const value = Number(doorData?.frameData?.[key]) || 0;
          totalWidth += value;

          const value_real = Number(doorData?.frameData?.[`windowWidth${i}_d_real`]) || 0;
          totalWidth_real += value_real;
        }
      }

      // Set totals
      doorData.frameData.totalMainSquare = totalMainSquare.toFixed(2);
      doorData.frameData.totalTopSquare = totalTopSquare.toFixed(2);

      totalWidth = totalWidth / SCALE;

      doorData.frameData.mainRowHeight_d = doorData?.frameData?.windowHeight_d / SCALE || 0;
      doorData.frameData.mainRowHeight_d_real = parseFloat(doorData?.frameData?.windowHeight_d_real) || 0;
      doorData.frameData.mainRowWidth_d = totalWidth;
      doorData.frameData.mainRowWidth_d_real = totalWidth_real;

      doorData.frameData.mainRowWidth = formatToFractional(totalWidth);
      doorData.frameData.mainRowHeight = formatToFractional(doorData?.frameData?.mainRowHeight_d);

      if (topRowConfValue === "None") {
        doorData.frameData.uHeight = 0;
        doorData.frameData.uHeight_d = 0;
        doorData.frameData.uHeight_d_real = 0;
      }

      // Total square (main + top)
      doorData.frameData.totalSquare = (parseFloat(doorData?.frameData?.mainRowHeight_d_real || 0) + parseFloat(doorData?.frameData?.uHeight_d_real || 0)) *
                                        parseFloat(doorData?.frameData?.mainRowWidth_d_real || 0) / 144;
    }//calcSquares

    const calcShapeArea = (shape, width, height, trapezoidData) => {
      // width and height in inches (real units)
      const W = width;
      const H = height;
      switch (shape) {
        case 'Rectangle':
        case 'Empty Spot':
          return W * H;
        case 'Triangle Left':
        case 'Triangle Right':
        case 'Triangle Center':
          return (W * H) / 2;
        case 'Trapezoid Left': {
          const leftSize = parseFloat(trapezoidData?.leftSize_d_real) || 0;
          // bottom base = W - leftSize, top base = W; area = (topBase + bottomBase) * H / 2
          return ((W + (W - leftSize)) * H) / 2;
        }
        case 'Trapezoid Right': {
          const rightSize = parseFloat(trapezoidData?.rightSize_d_real) || 0;
          return ((W + (W - rightSize)) * H) / 2;
        }
        case 'AngledTopTrapezoid Left': {
          const leftSize = parseFloat(trapezoidData?.leftSize_d_real) || 0;
          // left side = H - leftSize, right side = H; area = (leftSide + rightSide) * W / 2
          return (((H - leftSize) + H) * W) / 2;
        }
        case 'AngledTopTrapezoid Right': {
          const rightSize = parseFloat(trapezoidData?.rightSize_d_real) || 0;
          return ((H + (H - rightSize)) * W) / 2;
        }
        case 'Pentagon':
          // rectangle with triangular top (triangle = top half)
          return W * H * 3 / 4;
        case 'Octagon': {
          // cut all 4 corners; cut size = min(W,H) / 4
          const cut = Math.min(W, H) / 4;
          return W * H - 2 * cut * cut;
        }
        case 'Eyebrow':
          // half-ellipse: PI * a * b / 2, a = W/2, b = H
          return (Math.PI * (W / 2) * H) / 2;
        case 'HalfEyebrow Left':
        case 'HalfEyebrow Right':
          // quarter-ellipse
          return (Math.PI * (W / 2) * H) / 4;
        default:
          return W * H;
      }
    };

    const calcSquaresReal = () => {
      let [totalWidth, totalWidth_real] = [0, 0];
      const activeSections = parseInt(mainRowConfValue) || 0;
      let totalMainSquareReal = 0;
      let totalTopSquareReal = 0;

      const mainRowHeight = parseFloat(doorData?.frameData?.windowHeight_d_real) || 0;
      const topRowHeight = parseFloat(doorData?.frameData?.topRowHeight_d_real) || 0;

      for (let i = 1; i <= 5; i++) {
        const width = parseFloat(doorData?.frameData?.[`windowWidth${i}_d_real`]) || 0;

        // Main row
        if (i <= activeSections && width > 0 && mainRowHeight > 0) {
          const shape = doorData?.frameData?.[`shape${i}`] || 'Rectangle';
          const trapData = doorData?.frameData?.[`trapezoid${i}`] || {};
          const areaIn2 = calcShapeArea(shape, width, mainRowHeight, trapData);
          const squareVal = areaIn2 / 144;
          doorData.frameData[`squareReal${i}`] = squareVal.toFixed(2);
          totalMainSquareReal += squareVal;
        } else {
          doorData.frameData[`squareReal${i}`] = "0.00";
        }

        // Top row
        if (i <= activeSections && topRowConfValue !== "None" && width > 0 && topRowHeight > 0) {
          const shapeTop = doorData?.frameData?.[`shapeTop${i}`] || 'Rectangle';
          const trapTopData = doorData?.frameData?.[`trapezoidTop${i}`] || {};
          const areaIn2 = calcShapeArea(shapeTop, width, topRowHeight, trapTopData);
          const topSquareVal = areaIn2 / 144;
          doorData.frameData[`topsquareReal${i}`] = topSquareVal.toFixed(2);
          totalTopSquareReal += topSquareVal;
        } else {
          doorData.frameData[`topsquareReal${i}`] = "0.00";
        }

        if (i <= activeSections) {
          totalWidth += Number(doorData?.frameData?.[`windowWidth${i}_d`]) || 0;
          totalWidth_real += Number(doorData?.frameData?.[`windowWidth${i}_d_real`]) || 0;
        }
      }

      doorData.frameData.totalMainSquareReal = totalMainSquareReal.toFixed(2);
      doorData.frameData.totalTopSquareReal = totalTopSquareReal.toFixed(2);
      doorData.frameData.totalSquareReal = (totalMainSquareReal + totalTopSquareReal).toFixed(2);
    }//calcSquaresReal

    const calcPerimeters = () => {
      const activeSections = parseInt(mainRowConfValue) || 0;
      let totalMainPerimeter = 0;
      let totalTopPerimeter = 0;

      // Main row height
      const mainRowHeight = parseFloat(doorData?.frameData?.windowHeight_d_real) || 0;
      // Top row height
      const topRowHeight = parseFloat(doorData?.frameData?.topRowHeight_d_real) || 0;

      // Calculate perimeters for sections 1-5 (main row and top row)
      for (let i = 1; i <= 5; i++) {
        const width = parseFloat(doorData?.frameData?.[`windowWidth${i}_d_real`]) || 0;

        // Main row perimeter (rectangle only: 2 * (w + h) / 12)
        if (i <= activeSections && width > 0 && mainRowHeight > 0) {
          const perimeterVal = (2 * (width + mainRowHeight)) / 12;
          doorData.frameData[`perimeter${i}`] = perimeterVal.toFixed(2);
          totalMainPerimeter += perimeterVal;
        } else {
          doorData.frameData[`perimeter${i}`] = "0.00";
        }

        // Top row perimeter (rectangle only: 2 * (w + h) / 12)
        if (i <= activeSections && topRowConfValue !== "None" && width > 0 && topRowHeight > 0) {
          const topPerimeterVal = (2 * (width + topRowHeight)) / 12;
          doorData.frameData[`topperimeter${i}`] = topPerimeterVal.toFixed(2);
          totalTopPerimeter += topPerimeterVal;
        } else {
          doorData.frameData[`topperimeter${i}`] = "0.00";
        }
      }

      // Set totals
      doorData.frameData.totalMainPerimeter = totalMainPerimeter.toFixed(2);
      doorData.frameData.totalTopPerimeter = totalTopPerimeter.toFixed(2);
    }//calcPerimeters

    // Prepare props for all section functions
    const sectionProps = {
      SECTIONS,
      isDisabled,
      // Configuration
      topRowConfValue, setTopRowConfValue,
      archLegHeightValue, setArchLegHeightValue,
      topRowHeightValue, setTopRowHeightValue,
      mainRowConfValue, setMainRowConfValue,
      totalWindowWidthValue, setTotalWindowWidthValue,
      windowHeightValue, setWindowHeightValue,
      setWindowWidthValue1, setWindowWidthValue2, setWindowWidthValue3, setWindowWidthValue4, setWindowWidthValue5,
      setProperTopRowSectionTitle,
      // Window types
      windowTypeTopValue1, setWindowTypeTopValue1,
      windowTypeTopValue2, setWindowTypeTopValue2,
      windowTypeTopValue3, setWindowTypeTopValue3,
      windowTypeTopValue4, setWindowTypeTopValue4,
      windowTypeTopValue5, setWindowTypeTopValue5,

      windowShapeTopValue1, setWindowShapeTopValue1,
      windowShapeTopValue2, setWindowShapeTopValue2,
      windowShapeTopValue3, setWindowShapeTopValue3,
      windowShapeTopValue4, setWindowShapeTopValue4,
      windowShapeTopValue5, setWindowShapeTopValue5,

      //->
    trapezoidTopLeftSizeValue1, setTrapezoidTopLeftSizeValue1,
    trapezoidTopLeftSizeValue2, setTrapezoidTopLeftSizeValue2,
    trapezoidTopLeftSizeValue3, setTrapezoidTopLeftSizeValue3,
    trapezoidTopLeftSizeValue4, setTrapezoidTopLeftSizeValue4,
    trapezoidTopLeftSizeValue5, setTrapezoidTopLeftSizeValue5,

    trapezoidTopRightSizeValue1, setTrapezoidTopRightSizeValue1,
    trapezoidTopRightSizeValue2, setTrapezoidTopRightSizeValue2,
    trapezoidTopRightSizeValue3, setTrapezoidTopRightSizeValue3,
    trapezoidTopRightSizeValue4, setTrapezoidTopRightSizeValue4,
    trapezoidTopRightSizeValue5, setTrapezoidTopRightSizeValue5,   

    angledTopTrapezoidTopLeftSizeValue1, setAngledTopTrapezoidTopLeftSizeValue1,
    angledTopTrapezoidTopLeftSizeValue2, setAngledTopTrapezoidTopLeftSizeValue2,
    angledTopTrapezoidTopLeftSizeValue3, setAngledTopTrapezoidTopLeftSizeValue3,
    angledTopTrapezoidTopLeftSizeValue4, setAngledTopTrapezoidTopLeftSizeValue4,
    angledTopTrapezoidTopLeftSizeValue5, setAngledTopTrapezoidTopLeftSizeValue5,

    angledTopTrapezoidTopRightSizeValue1, setAngledTopTrapezoidTopRightSizeValue1,
    angledTopTrapezoidTopRightSizeValue2, setAngledTopTrapezoidTopRightSizeValue2,
    angledTopTrapezoidTopRightSizeValue3, setAngledTopTrapezoidTopRightSizeValue3,
    angledTopTrapezoidTopRightSizeValue4, setAngledTopTrapezoidTopRightSizeValue4,
    angledTopTrapezoidTopRightSizeValue5, setAngledTopTrapezoidTopRightSizeValue5,
      //->

      windowTypeValue1, setWindowTypeValue1,
      windowTypeValue2, setWindowTypeValue2,
      windowTypeValue3, setWindowTypeValue3,
      windowTypeValue4, setWindowTypeValue4,
      windowTypeValue5, setWindowTypeValue5,

      windowShapeValue1, setWindowShapeValue1,
      windowShapeValue2, setWindowShapeValue2,
      windowShapeValue3, setWindowShapeValue3,
      windowShapeValue4, setWindowShapeValue4,
      windowShapeValue5, setWindowShapeValue5,

    trapezoidLeftSizeValue1, setTrapezoidLeftSizeValue1,
    trapezoidLeftSizeValue2, setTrapezoidLeftSizeValue2,
    trapezoidLeftSizeValue3, setTrapezoidLeftSizeValue3,
    trapezoidLeftSizeValue4, setTrapezoidLeftSizeValue4,
    trapezoidLeftSizeValue5, setTrapezoidLeftSizeValue5,

    trapezoidRightSizeValue1, setTrapezoidRightSizeValue1,
    trapezoidRightSizeValue2, setTrapezoidRightSizeValue2,
    trapezoidRightSizeValue3, setTrapezoidRightSizeValue3,
    trapezoidRightSizeValue4, setTrapezoidRightSizeValue4,
    trapezoidRightSizeValue5, setTrapezoidRightSizeValue5,   

    angledTopTrapezoidLeftSizeValue1, setAngledTopTrapezoidLeftSizeValue1,
    angledTopTrapezoidLeftSizeValue2, setAngledTopTrapezoidLeftSizeValue2,
    angledTopTrapezoidLeftSizeValue3, setAngledTopTrapezoidLeftSizeValue3,
    angledTopTrapezoidLeftSizeValue4, setAngledTopTrapezoidLeftSizeValue4,
    angledTopTrapezoidLeftSizeValue5, setAngledTopTrapezoidLeftSizeValue5,

    angledTopTrapezoidRightSizeValue1, setAngledTopTrapezoidRightSizeValue1,
    angledTopTrapezoidRightSizeValue2, setAngledTopTrapezoidRightSizeValue2,
    angledTopTrapezoidRightSizeValue3, setAngledTopTrapezoidRightSizeValue3,
    angledTopTrapezoidRightSizeValue4, setAngledTopTrapezoidRightSizeValue4,
    angledTopTrapezoidRightSizeValue5, setAngledTopTrapezoidRightSizeValue5,

      // Window widths
      windowWidthValue1, setWindowWidthValue1,
      windowWidthValue2, setWindowWidthValue2,
      windowWidthValue3, setWindowWidthValue3,
      windowWidthValue4, setWindowWidthValue4,
      windowWidthValue5, setWindowWidthValue5,
      // Hinges
      hingesTopValue1, setHingesTopValue1,
      hingesTopValue2, setHingesTopValue2,
      hingesTopValue3, setHingesTopValue3,
      hingesTopValue4, setHingesTopValue4,
      hingesTopValue5, setHingesTopValue5,
      hingesValue1, setHingesValue1,
      hingesValue2, setHingesValue2,
      hingesValue3, setHingesValue3,
      hingesValue4, setHingesValue4,
      hingesValue5, setHingesValue5,
      // Sliders
      sliderTopValue1, setSliderTopValue1,
      sliderTopValue2, setSliderTopValue2,
      sliderTopValue3, setSliderTopValue3,
      sliderTopValue4, setSliderTopValue4,
      sliderTopValue5, setSliderTopValue5,
      sliderValue1, setSliderValue1,
      sliderValue2, setSliderValue2,
      sliderValue3, setSliderValue3,
      sliderValue4, setSliderValue4,
      sliderValue5, setSliderValue5,
      // Tilt and Turn
      tiltAndTurnTopValue1, setTiltAndTurnTopValue1,
      tiltAndTurnTopValue2, setTiltAndTurnTopValue2,
      tiltAndTurnTopValue3, setTiltAndTurnTopValue3,
      tiltAndTurnTopValue4, setTiltAndTurnTopValue4,
      tiltAndTurnTopValue5, setTiltAndTurnTopValue5,
      tiltAndTurnValue1, setTiltAndTurnValue1,
      tiltAndTurnValue2, setTiltAndTurnValue2,
      tiltAndTurnValue3, setTiltAndTurnValue3,
      tiltAndTurnValue4, setTiltAndTurnValue4,
      tiltAndTurnValue5, setTiltAndTurnValue5,
     // Radius x & Radius y - oculus
      radiusxTopValue1, setRadiusxTopValue1,
      radiusxTopValue2, setRadiusxTopValue2,
      radiusxTopValue3, setRadiusxTopValue3,
      radiusxTopValue4, setRadiusxTopValue4,
      radiusxTopValue5, setRadiusxTopValue5,

      radiusyTopValue1, setRadiusyTopValue1,
      radiusyTopValue2, setRadiusyTopValue2,
      radiusyTopValue3, setRadiusyTopValue3,
      radiusyTopValue4, setRadiusyTopValue4,
      radiusyTopValue5, setRadiusyTopValue5,
      
      radiusxValue1, setRadiusxValue1,
      radiusxValue2, setRadiusxValue2,
      radiusxValue3, setRadiusxValue3,
      radiusxValue4, setRadiusxValue4,
      radiusxValue5, setRadiusxValue5,

      radiusyValue1, setRadiusyValue1,
      radiusyValue2, setRadiusyValue2,
      radiusyValue3, setRadiusyValue3,
      radiusyValue4, setRadiusyValue4,
      radiusyValue5, setRadiusyValue5,
      // Arch grills
      archGrillTypeValue1, setArchGrillTypeValue1,
      archGrillSizeValue1, setArchGrillSizeValue1,
      archGrillPatternValue1, setArchGrillPatternValue1,
      archRaysGrillsValue1, setRaysGrillsValue1,
      archHorizontalGrillsValue1, setArchHorizontalGrillsValue1,
      archVerticalGrillsValue1, setArchVerticalGrillsValue1,
      // Finish
      interiorColorValue, setInteriorColorValue,
      exteriorColorValue, setExteriorColorValue,
      colorFinishingValue, setColorFinishingValue,
      grillsInteriorColorValue, setGrillsInteriorColorValue,
      grillsExteriorColorValue, setGrillsExteriorColorValue,
      // Glass
      glassTypeValue1, setGlassTypeValue1,
      texturedDesignValue1, setTexturedDesignValue1,
      tintedDesignValue1, setTintedDesignValue1,
      glazingTypeValue1, setGlazingTypeValue1,
      glassEnergyValue1, setGlassEnergyValue1,
      neatGlassValue1, setNeatGlassValue1,
      glassStrengthValue1, setGlassStrengthValue1,
      glassThicknessValue1, setGlassThicknessValue1,
      setMinMaxW,
      // Top Grills
      grillTypeTopValue1, setGrillTypeTopValue1,
      grillTypeTopValue2, setGrillTypeTopValue2,
      grillTypeTopValue3, setGrillTypeTopValue3,
      grillTypeTopValue4, setGrillTypeTopValue4,
      grillTypeTopValue5, setGrillTypeTopValue5,
      grillSizeTopValue1, setGrillSizeTopValue1,
      grillSizeTopValue2, setGrillSizeTopValue2,
      grillSizeTopValue3, setGrillSizeTopValue3,
      grillSizeTopValue4, setGrillSizeTopValue4,
      grillSizeTopValue5, setGrillSizeTopValue5,
      grillPatternTopValue1, setGrillPatternTopValue1,
      grillPatternTopValue2, setGrillPatternTopValue2,
      grillPatternTopValue3, setGrillPatternTopValue3,
      grillPatternTopValue4, setGrillPatternTopValue4,
      grillPatternTopValue5, setGrillPatternTopValue5,
      horizontalGrillsTopValue1, setHorizontalGrillsTopValue1,
      horizontalGrillsTopValue2, setHorizontalGrillsTopValue2,
      horizontalGrillsTopValue3, setHorizontalGrillsTopValue3,
      horizontalGrillsTopValue4, setHorizontalGrillsTopValue4,
      horizontalGrillsTopValue5, setHorizontalGrillsTopValue5,
      verticalGrillsTopValue1, setVerticalGrillsTopValue1,
      verticalGrillsTopValue2, setVerticalGrillsTopValue2,
      verticalGrillsTopValue3, setVerticalGrillsTopValue3,
      verticalGrillsTopValue4, setVerticalGrillsTopValue4,
      verticalGrillsTopValue5, setVerticalGrillsTopValue5,
      // Grills
      grillTypeValue1, setGrillTypeValue1,
      grillTypeValue2, setGrillTypeValue2,
      grillTypeValue3, setGrillTypeValue3,
      grillTypeValue4, setGrillTypeValue4,
      grillTypeValue5, setGrillTypeValue5,
      grillSizeValue1, setGrillSizeValue1,
      grillSizeValue2, setGrillSizeValue2,
      grillSizeValue3, setGrillSizeValue3,
      grillSizeValue4, setGrillSizeValue4,
      grillSizeValue5, setGrillSizeValue5,
      grillPatternValue1, setGrillPatternValue1,
      grillPatternValue2, setGrillPatternValue2,
      grillPatternValue3, setGrillPatternValue3,
      grillPatternValue4, setGrillPatternValue4,
      grillPatternValue5, setGrillPatternValue5,
      horizontalGrillsValue1, setHorizontalGrillsValue1,
      horizontalGrillsValue2, setHorizontalGrillsValue2,
      horizontalGrillsValue3, setHorizontalGrillsValue3,
      horizontalGrillsValue4, setHorizontalGrillsValue4,
      horizontalGrillsValue5, setHorizontalGrillsValue5,
      verticalGrillsValue1, setVerticalGrillsValue1,
      verticalGrillsValue2, setVerticalGrillsValue2,
      verticalGrillsValue3, setVerticalGrillsValue3,
      verticalGrillsValue4, setVerticalGrillsValue4,
      verticalGrillsValue5, setVerticalGrillsValue5,
      // Additional Items
      CascadingComboValue, setCascadingComboValue,
      // Installation
      installationTypeValue, setInstallationTypeValue,
      exteriorTypeValue, setExteriorTypeValue,
      brickmoldSizeValue, setBrickmoldSizeValue,
      brickmoldColorValue, setBrickmoldColorValue,
      jambTypeValue, setJambTypeValue,
      interiorCasingValue, setInteriorCasingValue,
      interiorCasingSizeValue, setInteriorCasingSizeValue,
      frameDepthValue, setFrameDepthValue,
      // Notes
      locationTagValue, setLocationTagValue,
      notesValue, setNotesValue,
      // Discounts
      ctrl_discount_enabled,
      discountValue, setDiscountValue,
      quantityValue, setQuantityValue,
    };

    const controlMap = [
      ...getConfigurationSection(sectionProps),
      ...getSizingAndFrameTopSection(sectionProps),
      ...getSizingAndFrameSection(sectionProps),
      ...getFinishSection(sectionProps),
      ...getGlassSection(sectionProps),
      ...getGrillsTopSection(sectionProps),
      ...getGrillsSection(sectionProps),
      ...getAdditionalItemsSection(sectionProps),
      ...getInstallationSection(sectionProps),
      ...getNotesSection(sectionProps),
      ...getDiscountsSection(sectionProps),
    ].filter(Boolean); // Filter out any false/undefined values from conditional renders
    if (!doorData.calc) {
        setDoorData((prev) => ({
          ...prev,
          calc: {
            baseSubtotal: null,
            subtotal: null,
            discountedSubtotal: null,
            tax: null,
            total: null,
          },
        }));
      }
     // Callback to update calc data
    const updateCalcData = (newCalc) => {
        setDoorData((prev) => ({
        ...prev,
        calc: {
            ...prev.calc,
            ...newCalc, // Merge new calc values
        },
        }));
    };
    const getCaption = () =>{
      let caption;
      if (topRowConfValue === "None"){ /* main row only */
        let panel  = " panels";
        if (doorData.frameData.nSections === "1") {
          panel = " panel";
        }
        caption = "1 row, " + doorData.frameData.nSections + panel;
        return caption;
      }
      if (topRowConfValue === "1"){
        let panel  = " panels";
        caption = "2 rows, " + (parseInt(doorData.frameData.nSections) + 1) + panel;
        return caption;
      }
      if (topRowConfValue === "Grid"){
        let panel  = " panels";
        caption = "2 rows, " + (parseInt(doorData.frameData.nSections) * 2) + panel;
        return caption;
      }
      if (['Arch', 'ArchBar', 'ArchGrid' ].includes(topRowConfValue)){
        let panel  = " panel Circ Seg";
        caption = "2 rows, " + (parseInt(doorData.frameData.nSections) + 1) + panel;
        return caption;
      } 
      return "error: unknown case";
    }

  ///let doorData = {}; - old one
  doorData.calc = doorData.calc || {};
  doorData.frameData = {}; 
  
  doorData.frameData.trapezoid1 = {};
  doorData.frameData.trapezoid2 = {};
  doorData.frameData.trapezoid3 = {};
  doorData.frameData.trapezoid4 = {};
  doorData.frameData.trapezoid5 = {};
  doorData.frameData.angledTopTrapezoid1 = {};
  doorData.frameData.angledTopTrapezoid2 = {};
  doorData.frameData.angledTopTrapezoid3 = {};
  doorData.frameData.angledTopTrapezoid4 = {};
  doorData.frameData.angledTopTrapezoid5 = {};

  doorData.frameData.trapezoidTop1 = {};
  doorData.frameData.trapezoidTop2 = {};
  doorData.frameData.trapezoidTop3 = {};
  doorData.frameData.trapezoidTop4 = {};
  doorData.frameData.trapezoidTop5 = {};
  doorData.frameData.angledTopTrapezoidTop1 = {};
  doorData.frameData.angledTopTrapezoidTop2 = {};
  doorData.frameData.angledTopTrapezoidTop3 = {};
  doorData.frameData.angledTopTrapezoidTop4 = {};
  doorData.frameData.angledTopTrapezoidTop5 = {};

  doorData.frameData.selectedDoor = {}; //for compartibility with doors
  doorData.transomData = {}; 
  doorData.doorLite = {};
  doorData.glass = {};
  doorData.grills = {};
  doorData.finish = {};
  doorData.notes = {};
  doorData.additionalItems = {};
  doorData.installation = {};
  doorData.discounts = {};
  doorData.document = {};
  doorData.document.type = DOCUMENT_TYPE;
  doorData.document.orderNumber = `${quoteId}/${quoteItemId || newQuoteItemId || 'new item'}`; //, fkCustomerId
  doorData.document.quoteId = quoteId;
  doorData.document.quoteItemId = quoteItemId;

  doorData.document.reference = `${reference_no}`;
  doorData.document.orderDate = `${lastDateSaved}`;
 
  doorData.quoteTemplate = QUOTE_TEMPLATE;
  doorData.priceRules = PRICE_RULES;
  //doorData.frameData.name = ITEM_NAME;

  doorData.displayPrices = displayPrices;

  doorData.quote = 1;
  doorData.frameData.nSections = mainRowConfValue;//SECTIONS;
  doorData.frameData.frameWidth = 200;
  doorData.frameData.frameHeight = 150;

  doorData.frameData.topRowConf = topRowConfValue;

  //Top row
  doorData.frameData.typeTop1 = windowTypeTopValue1;
  doorData.frameData.typeTop2 = windowTypeTopValue2;
  doorData.frameData.typeTop3 = windowTypeTopValue3;
  doorData.frameData.typeTop4 = windowTypeTopValue4;
  doorData.frameData.typeTop5 = windowTypeTopValue5;

  doorData.frameData.shapeTop1 = windowShapeTopValue1;
  doorData.frameData.shapeTop2 = windowShapeTopValue2;
  doorData.frameData.shapeTop3 = windowShapeTopValue3;
  doorData.frameData.shapeTop4 = windowShapeTopValue4;
  doorData.frameData.shapeTop5 = windowShapeTopValue5;

  //->
  doorData.frameData.trapezoidTop1.leftSize = trapezoidTopLeftSizeValue1; //ccc
  doorData.frameData.trapezoidTop1.leftSize_d = SCALE*formatToDecimal(trapezoidTopLeftSizeValue1);
  doorData.frameData.trapezoidTop1.leftSize_d_real = formatToDecimal(trapezoidTopLeftSizeValue1);  
  doorData.frameData.trapezoidTop2.leftSize = trapezoidTopLeftSizeValue2;
  doorData.frameData.trapezoidTop2.leftSize_d = SCALE*formatToDecimal(trapezoidTopLeftSizeValue2);
  doorData.frameData.trapezoidTop2.leftSize_d_real = formatToDecimal(trapezoidTopLeftSizeValue2);
  doorData.frameData.trapezoidTop3.leftSize = trapezoidTopLeftSizeValue3;
  doorData.frameData.trapezoidTop3.leftSize_d = SCALE*formatToDecimal(trapezoidTopLeftSizeValue3);
  doorData.frameData.trapezoidTop3.leftSize_d_real = formatToDecimal(trapezoidTopLeftSizeValue3);
  doorData.frameData.trapezoidTop4.leftSize = trapezoidTopLeftSizeValue4;
  doorData.frameData.trapezoidTop4.leftSize_d = SCALE*formatToDecimal(trapezoidTopLeftSizeValue4);
  doorData.frameData.trapezoidTop4.leftSize_d_real = formatToDecimal(trapezoidTopLeftSizeValue4);
  doorData.frameData.trapezoidTop5.leftSize = trapezoidTopLeftSizeValue5;
  doorData.frameData.trapezoidTop5.leftSize_d = SCALE*formatToDecimal(trapezoidTopLeftSizeValue5);
  doorData.frameData.trapezoidTop5.leftSize_d_real = formatToDecimal(trapezoidTopLeftSizeValue5);

  doorData.frameData.trapezoidTop1.rightSize = trapezoidTopRightSizeValue1;
  doorData.frameData.trapezoidTop1.rightSize_d = SCALE*formatToDecimal(trapezoidTopRightSizeValue1);
  doorData.frameData.trapezoidTop1.rightSize_d_real = formatToDecimal(trapezoidTopRightSizeValue1);  
  doorData.frameData.trapezoidTop2.rightSize = trapezoidTopRightSizeValue2;
  doorData.frameData.trapezoidTop2.rightSize_d = SCALE*formatToDecimal(trapezoidTopRightSizeValue2);
  doorData.frameData.trapezoidTop2.rightSize_d_real = formatToDecimal(trapezoidTopRightSizeValue2);
  doorData.frameData.trapezoidTop3.rightSize = trapezoidTopRightSizeValue3;
  doorData.frameData.trapezoidTop3.rightSize_d = SCALE*formatToDecimal(trapezoidTopRightSizeValue3);
  doorData.frameData.trapezoidTop3.rightSize_d_real = formatToDecimal(trapezoidTopRightSizeValue3);
  doorData.frameData.trapezoidTop4.rightSize = trapezoidTopRightSizeValue4;
  doorData.frameData.trapezoidTop4.rightSize_d = SCALE*formatToDecimal(trapezoidTopRightSizeValue4);
  doorData.frameData.trapezoidTop4.rightSize_d_real = formatToDecimal(trapezoidTopRightSizeValue4);
  doorData.frameData.trapezoidTop5.rightSize = trapezoidTopRightSizeValue5;
  doorData.frameData.trapezoidTop5.rightSize_d = SCALE*formatToDecimal(trapezoidTopRightSizeValue5);
  doorData.frameData.trapezoidTop5.rightSize_d_real = formatToDecimal(trapezoidTopRightSizeValue5);

  doorData.frameData.angledTopTrapezoidTop1.leftSize = angledTopTrapezoidTopLeftSizeValue1;
  doorData.frameData.angledTopTrapezoidTop1.leftSize_d = SCALE*formatToDecimal(angledTopTrapezoidTopLeftSizeValue1);
  doorData.frameData.angledTopTrapezoidTop1.leftSize_d_real = formatToDecimal(angledTopTrapezoidTopLeftSizeValue1);  
  doorData.frameData.angledTopTrapezoidTop2.leftSize = angledTopTrapezoidTopLeftSizeValue2;
  doorData.frameData.angledTopTrapezoidTop2.leftSize_d = SCALE*formatToDecimal(angledTopTrapezoidTopLeftSizeValue2);
  doorData.frameData.angledTopTrapezoidTop2.leftSize_d_real = formatToDecimal(angledTopTrapezoidTopLeftSizeValue2);
  doorData.frameData.angledTopTrapezoidTop3.leftSize = angledTopTrapezoidTopLeftSizeValue3;
  doorData.frameData.angledTopTrapezoidTop3.leftSize_d = SCALE*formatToDecimal(angledTopTrapezoidTopLeftSizeValue3);
  doorData.frameData.angledTopTrapezoidTop3.leftSize_d_real = formatToDecimal(angledTopTrapezoidTopLeftSizeValue3);
  doorData.frameData.angledTopTrapezoidTop4.leftSize = angledTopTrapezoidTopLeftSizeValue4;
  doorData.frameData.angledTopTrapezoidTop4.leftSize_d = SCALE*formatToDecimal(angledTopTrapezoidTopLeftSizeValue4);
  doorData.frameData.angledTopTrapezoidTop4.leftSize_d_real = formatToDecimal(angledTopTrapezoidTopLeftSizeValue4);
  doorData.frameData.angledTopTrapezoidTop5.leftSize = angledTopTrapezoidTopLeftSizeValue5;
  doorData.frameData.angledTopTrapezoidTop5.leftSize_d = SCALE*formatToDecimal(angledTopTrapezoidTopLeftSizeValue5);
  doorData.frameData.angledTopTrapezoidTop5.leftSize_d_real = formatToDecimal(angledTopTrapezoidTopLeftSizeValue5);

  doorData.frameData.angledTopTrapezoidTop1.rightSize = angledTopTrapezoidTopRightSizeValue1;
  doorData.frameData.angledTopTrapezoidTop1.rightSize_d = SCALE*formatToDecimal(angledTopTrapezoidTopRightSizeValue1);
  doorData.frameData.angledTopTrapezoidTop1.rightSize_d_real = formatToDecimal(angledTopTrapezoidTopRightSizeValue1);  
  doorData.frameData.angledTopTrapezoidTop2.rightSize = angledTopTrapezoidTopRightSizeValue2;
  doorData.frameData.angledTopTrapezoidTop2.rightSize_d = SCALE*formatToDecimal(angledTopTrapezoidTopRightSizeValue2);
  doorData.frameData.angledTopTrapezoidTop2.rightSize_d_real = formatToDecimal(angledTopTrapezoidTopRightSizeValue2);
  doorData.frameData.angledTopTrapezoidTop3.rightSize = angledTopTrapezoidTopRightSizeValue3;
  doorData.frameData.angledTopTrapezoidTop3.rightSize_d = SCALE*formatToDecimal(angledTopTrapezoidTopRightSizeValue3);
  doorData.frameData.angledTopTrapezoidTop3.rightSize_d_real = formatToDecimal(angledTopTrapezoidTopRightSizeValue3);
  doorData.frameData.angledTopTrapezoidTop4.rightSize = angledTopTrapezoidTopRightSizeValue4;
  doorData.frameData.angledTopTrapezoidTop4.rightSize_d = SCALE*formatToDecimal(angledTopTrapezoidTopRightSizeValue4);
  doorData.frameData.angledTopTrapezoidTop4.rightSize_d_real = formatToDecimal(angledTopTrapezoidTopRightSizeValue4);
  doorData.frameData.angledTopTrapezoidTop5.rightSize = angledTopTrapezoidTopRightSizeValue5;
  doorData.frameData.angledTopTrapezoidTop5.rightSize_d = SCALE*formatToDecimal(angledTopTrapezoidTopRightSizeValue5);
  doorData.frameData.angledTopTrapezoidTop5.rightSize_d_real = formatToDecimal(angledTopTrapezoidTopRightSizeValue5);
  //->

  doorData.frameData.hingesTop1 = hingesTopValue1; 
  doorData.frameData.hingesTop2 = hingesTopValue2;
  doorData.frameData.hingesTop3 = hingesTopValue3;
  doorData.frameData.hingesTop4 = hingesTopValue4;
  doorData.frameData.hingesTop5 = hingesTopValue5;

  doorData.frameData.sliderTop1 = sliderTopValue1; 
  doorData.frameData.sliderTop2 = sliderTopValue2;
  doorData.frameData.sliderTop3 = sliderTopValue3;
  doorData.frameData.sliderTop4 = sliderTopValue4;
  doorData.frameData.sliderTop5 = sliderTopValue5;
  
  doorData.frameData.tiltAndTurnTop1 = tiltAndTurnTopValue1; 
  doorData.frameData.tiltAndTurnTop2 = tiltAndTurnTopValue2;
  doorData.frameData.tiltAndTurnTop3 = tiltAndTurnTopValue3;
  doorData.frameData.tiltAndTurnTop4 = tiltAndTurnTopValue4;
  doorData.frameData.tiltAndTurnTop5 = tiltAndTurnTopValue5;

  doorData.frameData.radiusxTop1 = radiusxTopValue1;
  doorData.frameData.radiusxTop1_d = SCALE*formatToDecimal(radiusxTopValue1 || 0);
  doorData.frameData.radiusxTop1_d_real = formatToDecimal(radiusxTopValue1 || 0);
  doorData.frameData.radiusxTop2 = radiusxTopValue2;
  doorData.frameData.radiusxTop2_d = SCALE*formatToDecimal(radiusxTopValue2 || 0);
  doorData.frameData.radiusxTop2_d_real = formatToDecimal(radiusxTopValue2 || 0);
  doorData.frameData.radiusxTop3 = radiusxTopValue3;
  doorData.frameData.radiusxTop3_d = SCALE*formatToDecimal(radiusxTopValue3 || 0);
  doorData.frameData.radiusxTop3_d_real = formatToDecimal(radiusxTopValue3 || 0);
  doorData.frameData.radiusxTop4 = radiusxTopValue4;
  doorData.frameData.radiusxTop4_d = SCALE*formatToDecimal(radiusxTopValue4 || 0);
  doorData.frameData.radiusxTop4_d_real = formatToDecimal(radiusxTopValue4 || 0);
  doorData.frameData.radiusxTop5 = radiusxTopValue5;
  doorData.frameData.radiusxTop5_d = SCALE*formatToDecimal(radiusxTopValue5 || 0);
  doorData.frameData.radiusxTop5_d_real = formatToDecimal(radiusxTopValue5 || 0);

  doorData.frameData.radiusyTop1 = radiusyTopValue1;
  doorData.frameData.radiusyTop1_d = SCALE*formatToDecimal(radiusyTopValue1 || 0);
  doorData.frameData.radiusyTop1_d_real = formatToDecimal(radiusyTopValue1 || 0);
  doorData.frameData.radiusyTop2 = radiusyTopValue2;
  doorData.frameData.radiusyTop2_d = SCALE*formatToDecimal(radiusyTopValue2 || 0);
  doorData.frameData.radiusyTop2_d_real = formatToDecimal(radiusyTopValue2 || 0);
  doorData.frameData.radiusyTop3 = radiusyTopValue3;
  doorData.frameData.radiusyTop3_d = SCALE*formatToDecimal(radiusyTopValue3 || 0);
  doorData.frameData.radiusyTop3_d_real = formatToDecimal(radiusyTopValue3 || 0);
  doorData.frameData.radiusyTop4 = radiusyTopValue4;
  doorData.frameData.radiusyTop4_d = SCALE*formatToDecimal(radiusyTopValue4 || 0);
  doorData.frameData.radiusyTop4_d_real = formatToDecimal(radiusyTopValue4 || 0);
  doorData.frameData.radiusyTop5 = radiusyTopValue5;
  doorData.frameData.radiusyTop5_d = SCALE*formatToDecimal(radiusyTopValue5 || 0);
  doorData.frameData.radiusyTop5_d_real = formatToDecimal(radiusyTopValue5 || 0);
  //^^^

  doorData.frameData.type1 = windowTypeValue1;
  doorData.frameData.type2 = windowTypeValue2;
  doorData.frameData.type3 = windowTypeValue3;
  doorData.frameData.type4 = windowTypeValue4;
  doorData.frameData.type5 = windowTypeValue5;

  doorData.frameData.shape1 = windowShapeValue1;
  doorData.frameData.shape2 = windowShapeValue2;
  doorData.frameData.shape3 = windowShapeValue3;
  doorData.frameData.shape4 = windowShapeValue4;
  doorData.frameData.shape5 = windowShapeValue5;
 
  doorData.frameData.trapezoid1.leftSize = trapezoidLeftSizeValue1;
  doorData.frameData.trapezoid1.leftSize_d = SCALE*formatToDecimal(trapezoidLeftSizeValue1);
  doorData.frameData.trapezoid1.leftSize_d_real = formatToDecimal(trapezoidLeftSizeValue1);  
  doorData.frameData.trapezoid2.leftSize = trapezoidLeftSizeValue2;
  doorData.frameData.trapezoid2.leftSize_d = SCALE*formatToDecimal(trapezoidLeftSizeValue2);
  doorData.frameData.trapezoid2.leftSize_d_real = formatToDecimal(trapezoidLeftSizeValue2);
  doorData.frameData.trapezoid3.leftSize = trapezoidLeftSizeValue3;
  doorData.frameData.trapezoid3.leftSize_d = SCALE*formatToDecimal(trapezoidLeftSizeValue3);
  doorData.frameData.trapezoid3.leftSize_d_real = formatToDecimal(trapezoidLeftSizeValue3);
  doorData.frameData.trapezoid4.leftSize = trapezoidLeftSizeValue4;
  doorData.frameData.trapezoid4.leftSize_d = SCALE*formatToDecimal(trapezoidLeftSizeValue4);
  doorData.frameData.trapezoid4.leftSize_d_real = formatToDecimal(trapezoidLeftSizeValue4);
  doorData.frameData.trapezoid5.leftSize = trapezoidLeftSizeValue5;
  doorData.frameData.trapezoid5.leftSize_d = SCALE*formatToDecimal(trapezoidLeftSizeValue5);
  doorData.frameData.trapezoid5.leftSize_d_real = formatToDecimal(trapezoidLeftSizeValue5);

  doorData.frameData.trapezoid1.rightSize = trapezoidRightSizeValue1;
  doorData.frameData.trapezoid1.rightSize_d = SCALE*formatToDecimal(trapezoidRightSizeValue1);
  doorData.frameData.trapezoid1.rightSize_d_real = formatToDecimal(trapezoidRightSizeValue1);  
  doorData.frameData.trapezoid2.rightSize = trapezoidRightSizeValue2;
  doorData.frameData.trapezoid2.rightSize_d = SCALE*formatToDecimal(trapezoidRightSizeValue2);
  doorData.frameData.trapezoid2.rightSize_d_real = formatToDecimal(trapezoidRightSizeValue2);
  doorData.frameData.trapezoid3.rightSize = trapezoidRightSizeValue3;
  doorData.frameData.trapezoid3.rightSize_d = SCALE*formatToDecimal(trapezoidRightSizeValue3);
  doorData.frameData.trapezoid3.rightSize_d_real = formatToDecimal(trapezoidRightSizeValue3);
  doorData.frameData.trapezoid4.rightSize = trapezoidRightSizeValue4;
  doorData.frameData.trapezoid4.rightSize_d = SCALE*formatToDecimal(trapezoidRightSizeValue4);
  doorData.frameData.trapezoid4.rightSize_d_real = formatToDecimal(trapezoidRightSizeValue4);
  doorData.frameData.trapezoid5.rightSize = trapezoidRightSizeValue5;
  doorData.frameData.trapezoid5.rightSize_d = SCALE*formatToDecimal(trapezoidRightSizeValue5);
  doorData.frameData.trapezoid5.rightSize_d_real = formatToDecimal(trapezoidRightSizeValue5);

  doorData.frameData.angledTopTrapezoid1.leftSize = angledTopTrapezoidLeftSizeValue1;
  doorData.frameData.angledTopTrapezoid1.leftSize_d = SCALE*formatToDecimal(angledTopTrapezoidLeftSizeValue1);
  doorData.frameData.angledTopTrapezoid1.leftSize_d_real = formatToDecimal(angledTopTrapezoidLeftSizeValue1);  
  doorData.frameData.angledTopTrapezoid2.leftSize = angledTopTrapezoidLeftSizeValue2;
  doorData.frameData.angledTopTrapezoid2.leftSize_d = SCALE*formatToDecimal(angledTopTrapezoidLeftSizeValue2);
  doorData.frameData.angledTopTrapezoid2.leftSize_d_real = formatToDecimal(angledTopTrapezoidLeftSizeValue2);
  doorData.frameData.angledTopTrapezoid3.leftSize = angledTopTrapezoidLeftSizeValue3;
  doorData.frameData.angledTopTrapezoid3.leftSize_d = SCALE*formatToDecimal(angledTopTrapezoidLeftSizeValue3);
  doorData.frameData.angledTopTrapezoid3.leftSize_d_real = formatToDecimal(angledTopTrapezoidLeftSizeValue3);
  doorData.frameData.angledTopTrapezoid4.leftSize = angledTopTrapezoidLeftSizeValue4;
  doorData.frameData.angledTopTrapezoid4.leftSize_d = SCALE*formatToDecimal(angledTopTrapezoidLeftSizeValue4);
  doorData.frameData.angledTopTrapezoid4.leftSize_d_real = formatToDecimal(angledTopTrapezoidLeftSizeValue4);
  doorData.frameData.angledTopTrapezoid5.leftSize = angledTopTrapezoidLeftSizeValue5;
  doorData.frameData.angledTopTrapezoid5.leftSize_d = SCALE*formatToDecimal(angledTopTrapezoidLeftSizeValue5);
  doorData.frameData.angledTopTrapezoid5.leftSize_d_real = formatToDecimal(angledTopTrapezoidLeftSizeValue5);

  doorData.frameData.angledTopTrapezoid1.rightSize = angledTopTrapezoidRightSizeValue1;
  doorData.frameData.angledTopTrapezoid1.rightSize_d = SCALE*formatToDecimal(angledTopTrapezoidRightSizeValue1);
  doorData.frameData.angledTopTrapezoid1.rightSize_d_real = formatToDecimal(angledTopTrapezoidRightSizeValue1);  
  doorData.frameData.angledTopTrapezoid2.rightSize = angledTopTrapezoidRightSizeValue2;
  doorData.frameData.angledTopTrapezoid2.rightSize_d = SCALE*formatToDecimal(angledTopTrapezoidRightSizeValue2);
  doorData.frameData.angledTopTrapezoid2.rightSize_d_real = formatToDecimal(angledTopTrapezoidRightSizeValue2);
  doorData.frameData.angledTopTrapezoid3.rightSize = angledTopTrapezoidRightSizeValue3;
  doorData.frameData.angledTopTrapezoid3.rightSize_d = SCALE*formatToDecimal(angledTopTrapezoidRightSizeValue3);
  doorData.frameData.angledTopTrapezoid3.rightSize_d_real = formatToDecimal(angledTopTrapezoidRightSizeValue3);
  doorData.frameData.angledTopTrapezoid4.rightSize = angledTopTrapezoidRightSizeValue4;
  doorData.frameData.angledTopTrapezoid4.rightSize_d = SCALE*formatToDecimal(angledTopTrapezoidRightSizeValue4);
  doorData.frameData.angledTopTrapezoid4.rightSize_d_real = formatToDecimal(angledTopTrapezoidRightSizeValue4);
  doorData.frameData.angledTopTrapezoid5.rightSize = angledTopTrapezoidRightSizeValue5;
  doorData.frameData.angledTopTrapezoid5.rightSize_d = SCALE*formatToDecimal(angledTopTrapezoidRightSizeValue5);
  doorData.frameData.angledTopTrapezoid5.rightSize_d_real = formatToDecimal(angledTopTrapezoidRightSizeValue5);


  doorData.frameData.hinges1 = hingesValue1; 
  doorData.frameData.hinges2 = hingesValue2;
  doorData.frameData.hinges3 = hingesValue3;
  doorData.frameData.hinges4 = hingesValue4;
  doorData.frameData.hinges5 = hingesValue5;
 
  doorData.frameData.slider1 = sliderValue1; 
  doorData.frameData.slider2 = sliderValue2;
  doorData.frameData.slider3 = sliderValue3;
  doorData.frameData.slider4 = sliderValue4;
  doorData.frameData.slider5 = sliderValue5;
  
  doorData.frameData.tiltAndTurn1 = tiltAndTurnValue1; 
  doorData.frameData.tiltAndTurn2 = tiltAndTurnValue2;
  doorData.frameData.tiltAndTurn3 = tiltAndTurnValue3;
  doorData.frameData.tiltAndTurn4 = tiltAndTurnValue4;
  doorData.frameData.tiltAndTurn5 = tiltAndTurnValue5;

  doorData.frameData.radiusx1 = radiusxValue1;
  doorData.frameData.radiusx1_d = SCALE*formatToDecimal(radiusxValue1 || 0);
  doorData.frameData.radiusx1_d_real = formatToDecimal(radiusxValue1 || 0);
  doorData.frameData.radiusx2 = radiusxValue2;
  doorData.frameData.radiusx2_d = SCALE*formatToDecimal(radiusxValue2 || 0);
  doorData.frameData.radiusx2_d_real = formatToDecimal(radiusxValue2 || 0);
  doorData.frameData.radiusx3 = radiusxValue3;
  doorData.frameData.radiusx3_d = SCALE*formatToDecimal(radiusxValue3 || 0);
  doorData.frameData.radiusx3_d_real = formatToDecimal(radiusxValue3 || 0);
  doorData.frameData.radiusx4 = radiusxValue4;
  doorData.frameData.radiusx4_d = SCALE*formatToDecimal(radiusxValue4 || 0);
  doorData.frameData.radiusx4_d_real = formatToDecimal(radiusxValue4 || 0);
  doorData.frameData.radiusx5 = radiusxValue5;
  doorData.frameData.radiusx5_d = SCALE*formatToDecimal(radiusxValue5 || 0);
  doorData.frameData.radiusx5_d_real = formatToDecimal(radiusxValue5 || 0);

  doorData.frameData.radiusy1 = radiusyValue1;
  doorData.frameData.radiusy1_d = SCALE*formatToDecimal(radiusyValue1 || 0);
  doorData.frameData.radiusy1_d_real = formatToDecimal(radiusyValue1 || 0);
  doorData.frameData.radiusy2 = radiusyValue2;
  doorData.frameData.radiusy2_d = SCALE*formatToDecimal(radiusyValue2 || 0);
  doorData.frameData.radiusy2_d_real = formatToDecimal(radiusyValue2 || 0);
  doorData.frameData.radiusy3 = radiusyValue3;
  doorData.frameData.radiusy3_d = SCALE*formatToDecimal(radiusyValue3 || 0);
  doorData.frameData.radiusy3_d_real = formatToDecimal(radiusyValue3 || 0);
  doorData.frameData.radiusy4 = radiusyValue4;
  doorData.frameData.radiusy4_d = SCALE*formatToDecimal(radiusyValue4 || 0);
  doorData.frameData.radiusy4_d_real = formatToDecimal(radiusyValue4 || 0);
  doorData.frameData.radiusy5 = radiusyValue5;
  doorData.frameData.radiusy5_d = SCALE*formatToDecimal(radiusyValue5 || 0);
  doorData.frameData.radiusy5_d_real = formatToDecimal(radiusyValue5 || 0);

  doorData.frameData.topRowConf = topRowConfValue;
  doorData.frameData.name = ITEM_NAME + ' panel';
  if (topRowConfValue === "None"){
    doorData.frameData.uHeight   = 0;
    doorData.frameData.uHeight_d = 0;
    doorData.frameData.uHeight_d_real = 0;
    doorData.frameData.upperSection = 0;
    doorData.frameData.name = "1 row," + String( ITEM_NAME + 1) + " panels";
  }
  if (topRowConfValue === "Arch"){
    doorData.frameData.upperSection = 1;
    doorData.frameData.archLegHeight = archLegHeightValue;
    doorData.frameData.archLegHeight_d = SCALE*formatToDecimal(archLegHeightValue || 0);
    doorData.frameData.archLegHeight_d_real = formatToDecimal(archLegHeightValue || 0);

    doorData.frameData.archBar = false;
  }
  if (topRowConfValue === "ArchBar"){
    doorData.frameData.upperSection = 1;
    doorData.frameData.archLegHeight = archLegHeightValue;
    doorData.frameData.archLegHeight_d = SCALE*formatToDecimal(archLegHeightValue || 0);
    doorData.frameData.archLegHeight_d_real = formatToDecimal(archLegHeightValue || 0);

    doorData.frameData.archBar = true;
  }
  if (topRowConfValue === "ArchGrid"){
    doorData.frameData.upperSection = 1;
    doorData.frameData.archLegHeight = archLegHeightValue;
    doorData.frameData.archLegHeight_d = SCALE*formatToDecimal(archLegHeightValue || 0);
    doorData.frameData.archLegHeight_d_real = formatToDecimal(archLegHeightValue || 0);

    doorData.frameData.archBar = false;
  }
  if (topRowConfValue === "1" || ['Arch', 'ArchBar', 'ArchGrid'].includes(topRowConfValue)){
      doorData.frameData.upperSection = 1;
      doorData.frameData.name = "2 rows," + String( ITEM_NAME + 1) + " panels";
  }
  else{
    doorData.frameData.upperSection = mainRowConfValue;
    if (doorData.frameData.uHeight_d > 0){
      doorData.frameData.name = "2 rows," + String( 2*ITEM_NAME ) + " panels";
    }
  }

  doorData.frameData.uHeight   = topRowHeightValue;
  doorData.frameData.uHeight_d = SCALE*formatToDecimal(topRowHeightValue);
  doorData.frameData.uHeight_d_real  = formatToDecimal(topRowHeightValue);

  if (topRowConfValue === "None"){
    doorData.frameData.uHeight   = 0;
    doorData.frameData.uHeight_d = 0;
    doorData.frameData.uHeight_d_real = 0;
  }
  doorData.frameData.windowWidth1 = windowWidthValue1;
  doorData.frameData.windowWidth1_d = SCALE*formatToDecimal(windowWidthValue1);
  doorData.frameData.windowWidth1_d_real = formatToDecimal(windowWidthValue1);

  doorData.frameData.windowWidth2 = windowWidthValue2;
  doorData.frameData.windowWidth2_d = SCALE*formatToDecimal(windowWidthValue2);
  doorData.frameData.windowWidth2_d_real = formatToDecimal(windowWidthValue2);

  doorData.frameData.windowWidth3 = windowWidthValue3;
  doorData.frameData.windowWidth3_d = SCALE*formatToDecimal(windowWidthValue3);
  doorData.frameData.windowWidth3_d_real = formatToDecimal(windowWidthValue3);

  doorData.frameData.windowWidth4 = windowWidthValue4;
  doorData.frameData.windowWidth4_d = SCALE*formatToDecimal(windowWidthValue4);
  doorData.frameData.windowWidth4_d_real = formatToDecimal(windowWidthValue4);

  doorData.frameData.windowWidth5 = windowWidthValue5;
  doorData.frameData.windowWidth5_d = SCALE*formatToDecimal(windowWidthValue5);
  doorData.frameData.windowWidth5_d_real = formatToDecimal(windowWidthValue5);

  doorData.frameData.windowHeight = windowHeightValue;
  doorData.frameData.windowHeight_d = SCALE*formatToDecimal(windowHeightValue);
  doorData.frameData.windowHeight_d_real = formatToDecimal(windowHeightValue);

  doorData.frameData.topRowHeight   = topRowHeightValue || 0;
  doorData.frameData.topRowHeight_d = SCALE*formatToDecimal(doorData.frameData.topRowHeight);
  doorData.frameData.topRowHeight_d_real = formatToDecimal(doorData.frameData.topRowHeight);


  // Square calculations moved to calcSquares() function to support shape-based area calculations
  // The calcSquares() function is called below and handles both main row and top row squares
  /*
  if ( false ){ //rounded up to even
    doorData.frameData.square1 = (
        Math.ceil(((parseFloat(doorData?.frameData?.windowWidth1_d_real) || 0) *
        (parseFloat(doorData.frameData.windowHeight_d_real) || 0) / 144) / 2) * 2
    ).toFixed(2);
    doorData.frameData.square2 = (
        Math.ceil(((parseFloat(doorData?.frameData?.windowWidth2_d_real) || 0) *
        (parseFloat(doorData.frameData.windowHeight_d_real) || 0) / 144) / 2) * 2
    ).toFixed(2);
    doorData.frameData.square3 = (
        Math.ceil(((parseFloat(doorData?.frameData?.windowWidth3_d_real) || 0) *
        (parseFloat(doorData.frameData.windowHeight_d_real) || 0) / 144) / 2) * 2
    ).toFixed(2);
    doorData.frameData.square4 = (
        Math.ceil(((parseFloat(doorData?.frameData?.windowWidth4_d_real) || 0) *
        (parseFloat(doorData.frameData.windowHeight_d_real) || 0) / 144) / 2) * 2
    ).toFixed(2);
    doorData.frameData.square5 = (
        Math.ceil(((parseFloat(doorData?.frameData?.windowWidth5_d_real) || 0) *
        (parseFloat(doorData.frameData.windowHeight_d_real) || 0) / 144) / 2) * 2
    ).toFixed(2);

    doorData.frameData.topsquare1 = (
        Math.ceil(((parseFloat(doorData?.frameData?.windowWidth1_d_real) || 0) *
        (parseFloat(doorData.frameData.topRowHeight_d_real) || 0) / 144) / 2) * 2
    ).toFixed(2);
    doorData.frameData.topsquare2 = (
        Math.ceil(((parseFloat(doorData?.frameData?.windowWidth2_d_real) || 0) *
        (parseFloat(doorData.frameData.topRowHeight_d_real) || 0) / 144) / 2) * 2
    ).toFixed(2);
    doorData.frameData.topsquare3 = (
        Math.ceil(((parseFloat(doorData?.frameData?.windowWidth3_d_real) || 0) *
        (parseFloat(doorData.frameData.topRowHeight_d_real) || 0) / 144) / 2) * 2
    ).toFixed(2);
    doorData.frameData.topsquare4 = (
        Math.ceil(((parseFloat(doorData?.frameData?.windowWidth4_d_real) || 0) *
        (parseFloat(doorData.frameData.topRowHeight_d_real) || 0) / 144) / 2) * 2
    ).toFixed(2);
    doorData.frameData.topsquare5 = (
        Math.ceil(((parseFloat(doorData?.frameData?.windowWidth5_d_real) || 0) *
        (parseFloat(doorData.frameData.topRowHeight_d_real) || 0) / 144) / 2) * 2
    ).toFixed(2);
} else{
    doorData.frameData.square1 = ((parseFloat(doorData?.frameData?.windowWidth1_d_real) || 0) *
                                  (parseFloat(doorData.frameData.windowHeight_d_real) || 0) / 144).toFixed(2);
    doorData.frameData.square2 = ((parseFloat(doorData?.frameData?.windowWidth2_d_real) || 0) *
                                  (parseFloat(doorData.frameData.windowHeight_d_real) || 0) / 144).toFixed(2);
    doorData.frameData.square3 = ((parseFloat(doorData?.frameData?.windowWidth3_d_real) || 0) *
                                  (parseFloat(doorData.frameData.windowHeight_d_real) || 0) / 144).toFixed(2);
    doorData.frameData.square4 = ((parseFloat(doorData?.frameData?.windowWidth4_d_real) || 0) *
                                  (parseFloat(doorData.frameData.windowHeight_d_real) || 0) / 144).toFixed(2);
    doorData.frameData.square5 = ((parseFloat(doorData?.frameData?.windowWidth5_d_real) || 0) *
                                  (parseFloat(doorData.frameData.windowHeight_d_real) || 0) / 144).toFixed(2);

    doorData.frameData.topsquare1 = ((parseFloat(doorData?.frameData?.windowWidth1_d_real) || 0) *
                                  (parseFloat(doorData.frameData.topRowHeight_d_real) || 0) / 144).toFixed(2);
    doorData.frameData.topsquare2 = ((parseFloat(doorData?.frameData?.windowWidth2_d_real) || 0) *
                                  (parseFloat(doorData.frameData.topRowHeight_d_real) || 0) / 144).toFixed(2);
    doorData.frameData.topsquare3 = ((parseFloat(doorData?.frameData?.windowWidth3_d_real) || 0) *
                                  (parseFloat(doorData.frameData.topRowHeight_d_real) || 0) / 144).toFixed(2);
    doorData.frameData.topsquare4 = ((parseFloat(doorData?.frameData?.windowWidth4_d_real) || 0) *
                                  (parseFloat(doorData.frameData.topRowHeight_d_real) || 0) / 144).toFixed(2);
    doorData.frameData.topsquare5 = ((parseFloat(doorData?.frameData?.windowWidth5_d_real) || 0) *
                                  (parseFloat(doorData.frameData.topRowHeight_d_real) || 0) / 144).toFixed(2);
}
  */

  calcSquares();
  calcSquaresReal();
  calcPerimeters();

  doorData.glass.glassType1 = glassTypeValue1;
  doorData.glass.glassType2 = glassTypeValue1;
  doorData.glass.glassType3 = glassTypeValue1;
  doorData.glass.glassType4 = glassTypeValue1;
  doorData.glass.glassType5 = glassTypeValue1;

  doorData.glass.texturedDesign1 = texturedDesignValue1 || 'Frosted';
  doorData.glass.texturedDesign2 = texturedDesignValue1;
  doorData.glass.texturedDesign3 = texturedDesignValue1;
  doorData.glass.texturedDesign4 = texturedDesignValue1;
  doorData.glass.texturedDesign5 = texturedDesignValue1;

  doorData.glass.tintedDesign1 = tintedDesignValue1;// || 'Grey';
  doorData.glass.tintedDesign2 = tintedDesignValue1;
  doorData.glass.tintedDesign3 = tintedDesignValue1;
  doorData.glass.tintedDesign4 = tintedDesignValue1;
  doorData.glass.tintedDesign5 = tintedDesignValue1;

  doorData.glass.glazingType1     = glazingTypeValue1    || "Double";
  doorData.glass.glassEnergy1     = glassEnergyValue1    || "LowE 8071";
  doorData.glass.neatGlass1       = neatGlassValue1      || "No";
  doorData.glass.glassStrength1   = glassStrengthValue1  || "Annealed";
  doorData.glass.glassThickness1  = glassThicknessValue1 || "3mm";

 
  doorData.finish.interiorColor     = interiorColorValue || { value: "White", label: "White" };
  doorData.finish.exteriorColor     = exteriorColorValue || { value: "White", label: "White" };
  doorData.finish.colorFinishing    = colorFinishingValue || "None";

  doorData.frameData.archType = 'Top Arch';//aaa
  doorData.frameData.archShape = DEFAULT_SHAPE;
 
  doorData.grills.archGrillType = archGrillTypeValue1;
  doorData.grills.archGrillPattern = archGrillPatternValue1;
  doorData.grills.archGrillSize = archGrillSizeValue1 || "1\"";
  doorData.grills.archGlassDividers = true;
  doorData.grills.archVerticalGrills = archVerticalGrillsValue1;
  doorData.grills.archHorizontalGrills = archHorizontalGrillsValue1;

  doorData.grills.archRaysGrills = archRaysGrillsValue1;

  doorData.grills.exteriorFinish = grillsExteriorColorValue || { value: "white", label: "white" };
  doorData.grills.interiorFinish = grillsInteriorColorValue || { value: "white", label: "white" };
  
  /* top row grills...*/
  doorData.grills.grillTypeTop1 = grillTypeTopValue1;
  doorData.grills.grillsPatternTop1 = grillPatternTopValue1;
  doorData.grills.grillsSizeTop1 = grillSizeTopValue1;
  doorData.grills.glassDividersTop1 = true;
  doorData.grills.glassDividersVerticalTop1 = verticalGrillsTopValue1 || 0;
  doorData.grills.glassDividersHorizontalTop1 = horizontalGrillsTopValue1 || 0;

  doorData.grills.grillTypeTop2 = grillTypeTopValue2;
  doorData.grills.grillsPatternTop2 = grillPatternTopValue2;
  doorData.grills.grillsSizeTop2 = grillSizeTopValue2;
  doorData.grills.glassDividersTop2 = true;
  doorData.grills.glassDividersVerticalTop2 = verticalGrillsTopValue2 || 0;
  doorData.grills.glassDividersHorizontalTop2 = horizontalGrillsTopValue2 || 0;

  doorData.grills.grillTypeTop3 = grillTypeTopValue3;
  doorData.grills.grillsPatternTop3 = grillPatternTopValue3;
  doorData.grills.grillsSizeTop3 = grillSizeTopValue3;
  doorData.grills.glassDividersTop3 = true;
  doorData.grills.glassDividersVerticalTop3 = verticalGrillsTopValue3 || 0;
  doorData.grills.glassDividersHorizontalTop3 = horizontalGrillsTopValue3 || 0;

  doorData.grills.grillTypeTop4 = grillTypeTopValue4;
  doorData.grills.grillsPatternTop4 = grillPatternTopValue4;
  doorData.grills.grillsSizeTop4 = grillSizeTopValue4;
  doorData.grills.glassDividersTop4 = true;
  doorData.grills.glassDividersVerticalTop4 = verticalGrillsTopValue4 || 0;
  doorData.grills.glassDividersHorizontalTop4 = horizontalGrillsTopValue4 || 0;

  doorData.grills.grillTypeTop5 = grillTypeTopValue5;
  doorData.grills.grillsPatternTop5 = grillPatternTopValue5;
  doorData.grills.grillsSizeTop5 = grillSizeTopValue5;
  doorData.grills.glassDividersTop5 = true;
  doorData.grills.glassDividersVerticalTop5 = verticalGrillsTopValue5 || 0;
  doorData.grills.glassDividersHorizontalTop5 = horizontalGrillsTopValue5 || 0;

  /* main row grills...*/
  doorData.grills.grillType1 = grillTypeValue1;
  doorData.grills.grillsPattern1 = grillPatternValue1;
  doorData.grills.grillsSize1 = grillSizeValue1;
  doorData.grills.glassDividers1 = true;
  doorData.grills.glassDividersVertical1 = verticalGrillsValue1 || 0;
  doorData.grills.glassDividersHorizontal1 = horizontalGrillsValue1 || 0;
  doorData.grills.exteriorFinish = grillsExteriorColorValue;
  doorData.grills.interiorFinish = grillsInteriorColorValue;
  
  doorData.grills.grillType2 = grillTypeValue2;
  doorData.grills.grillsPattern2 = grillPatternValue2;
  doorData.grills.grillsSize2 = grillSizeValue2;
  doorData.grills.glassDividers2 = true;
  doorData.grills.glassDividersVertical2 = verticalGrillsValue2;
  doorData.grills.glassDividersHorizontal2 = horizontalGrillsValue2;
  doorData.grills.exteriorFinish = grillsExteriorColorValue;
  doorData.grills.interiorFinish = grillsInteriorColorValue;
  
  doorData.grills.grillType3 = grillTypeValue3;
  doorData.grills.grillsPattern3 = grillPatternValue3;
  doorData.grills.grillsSize3 = grillSizeValue3;
  doorData.grills.glassDividers3 = true;
  doorData.grills.glassDividersVertical3 = verticalGrillsValue3;
  doorData.grills.glassDividersHorizontal3 = horizontalGrillsValue3;
  doorData.grills.exteriorFinish = grillsExteriorColorValue;
  doorData.grills.interiorFinish = grillsInteriorColorValue;
  
  doorData.grills.grillType4 = grillTypeValue4;
  doorData.grills.grillsPattern4 = grillPatternValue4;
  doorData.grills.grillsSize4 = grillSizeValue4;
  doorData.grills.glassDividers4 = true;
  doorData.grills.glassDividersVertical4 = verticalGrillsValue4;
  doorData.grills.glassDividersHorizontal4 = horizontalGrillsValue4;
  doorData.grills.exteriorFinish = grillsExteriorColorValue;
  doorData.grills.interiorFinish = grillsInteriorColorValue;
  
  doorData.grills.grillType5 = grillTypeValue5;
  doorData.grills.grillsPattern5 = grillPatternValue5;
  doorData.grills.grillsSize5 = grillSizeValue5;
  doorData.grills.glassDividers5 = true;
  doorData.grills.glassDividersVertical5 = horizontalGrillsValue5;
  doorData.grills.glassDividersHorizontal5 = horizontalGrillsValue5;
  doorData.grills.exteriorFinish = grillsExteriorColorValue;
  doorData.grills.interiorFinish = grillsInteriorColorValue;

  doorData.installation.installationType   = installationTypeValue;
  doorData.installation.exteriorType       = exteriorTypeValue;
  doorData.installation.brickmoldSize      = brickmoldSizeValue;
  doorData.installation.brickmoldColor     = brickmoldColorValue || { value: "#FFFFFF", label: "White" };
  doorData.installation.jambType           = jambTypeValue;
  doorData.installation.interiorCasing     = interiorCasingValue;
  doorData.installation.interiorCasingSize = interiorCasingSizeValue;
  doorData.installation.frameDepth         = frameDepthValue  ;


  doorData.notes.LocationTag         = locationTagValue;
  doorData.notes.notes               = notesValue;

  doorData.frameData.quantity = quantityValue || 1;
  doorData.discounts.discount = discountValue || 0;

  CascadingComboValue.forEach(({ id, value }) => {
    doorData.additionalItems[id] = value;
  });
  requiredKeys.forEach(key => {
    if (!doorData.additionalItems.hasOwnProperty(key)) {
        doorData.additionalItems[key] = "NA";
    }
  });
  
  doorData.frameData.name = getCaption();
  doorData.frameData.selectedDoor.name = doorData?.frameData?.name || "Error, name is not defined"; //for compartibility with quotes.js

  //doorData.frameData.square1 = 6.5;
  //doorData.frameData.type1 = "FixedCasement";
  doorData.flipped = !flipped;

  // Capture initial state ONCE on very first render after data loads
  if (hasLoaded && initialDoorDataJSON === null && doorData && Object.keys(doorData).length > 0) {
    setInitialDoorDataJSON(JSON.stringify(doorData));
  }

  // Compare current doorData with initial state to detect changes
  const currentDoorDataJSON = JSON.stringify(doorData);
  const hasDataChanged = initialDoorDataJSON && (currentDoorDataJSON !== initialDoorDataJSON);

  const doorDataCopy  = { ...doorData };
  const doorDataCopy2 = { ...doorData };
  let moreOffsetX = flipped ? 40 : 0;

  // Scroll to section by expandableSectionId
  const scrollToSection = (sectionId) => {
    setSelectedSectionId(sectionId);
    setExpandedSections(prev => ({ ...prev, [sectionId]: true }));
    // Use setTimeout to allow React to render the section first when in showOnlySelected mode
    setTimeout(() => {
      const sectionElement = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 0);
  };

  // Handle section expand/collapse
  const handleSectionExpandChange = (sectionId, isExpanded) => {
    setExpandedSections(prev => ({ ...prev, [sectionId]: isExpanded }));
  };

  // Helper to check if section should be visible
  const isSectionVisible = (sectionId) => {
    if (!showOnlySelectedSection) return true;
    return selectedSectionId === sectionId;
  };

  // Helper to get forceExpanded value for a section
  const getForceExpanded = (sectionId) => {
    if (showOnlySelectedSection && selectedSectionId === sectionId) {
      return true; // Force expand when this is the selected section in showOnly mode
    }
    return null; // Let component manage its own state
  };

  // Determine which sections should be disabled in the nav menu
  const isGrillsTopAvailable = (topRowConfValue === "1" || topRowConfValue === 'Grid') &&
    ((windowTypeTopValue1 !== "None" && mainRowConfValue >= 1) ||
     (windowTypeTopValue2 !== "None" && mainRowConfValue >= 2) ||
     (windowTypeTopValue3 !== "None" && mainRowConfValue >= 3) ||
     (windowTypeTopValue4 !== "None" && mainRowConfValue >= 4) ||
     (windowTypeTopValue5 !== "None" && mainRowConfValue >= 5));

       
  const isGrillsAvailable = 
    (windowTypeValue1 !== "None" && mainRowConfValue >= 1) ||
    (windowTypeValue2 !== "None" && mainRowConfValue >= 2) ||
    (windowTypeValue3 !== "None" && mainRowConfValue >= 3) ||
    (windowTypeValue4 !== "None" && mainRowConfValue >= 4) ||
    (windowTypeValue5 !== "None" && mainRowConfValue >= 5);

  const isSizingAndFrameTopAvailable = topRowConfValue !== 'None';

  const disabledSections = {
    GrillsTop: !isGrillsTopAvailable,
    Grills: !isGrillsAvailable,
    SizingAndFrameTop: !isSizingAndFrameTopAvailable,
  };

return (
  <div className='entire-container' style={showTopBar ? { marginTop: '-1.5rem' } : undefined}>
    {enableFloatingNavMenu && !showTopBar && useSmallNavMenu && (
    <SmallFloatingNavMenu
      onNavigate={scrollToSection}
      showOnlySelected={showOnlySelectedSection}
      toggleShowOnlySelected={() => setShowOnlySelectedSection(prev => !prev)}
      selectedSectionId={selectedSectionId}
      disabledSections={disabledSections}
      onToggleSize={() => setUseSmallNavMenu(false)}
    />
    )}
    {enableFloatingNavMenu && !showTopBar && !useSmallNavMenu && (
    <LargeFloatingNavMenu
      onNavigate={scrollToSection}
      showOnlySelected={showOnlySelectedSection}
      toggleShowOnlySelected={() => setShowOnlySelectedSection(prev => !prev)}
      selectedSectionId={selectedSectionId}
      disabledSections={disabledSections}
      onToggleSize={() => setUseSmallNavMenu(true)}
    />
    )}
    {enableFloatingToolbarMenu && !showTopBar && (
    <SmallFloatingToolbarMenu
      isViewDetailsVisible={isViewDetailsVisible}
      toggleViewDetails={toggleViewDetails}
      displayPrices={displayPrices}
      togglePrices={togglePrices}
      isLoading={isLoading}
      handlePdfDownload={handlePdfDownload}
      handleSendEmail={handleSendEmail}
      handleSaveQuote={handleSaveQuote}
      flipped={flipped}
      handleFlipToggle={handleFlipToggle}
      handleZoomIn={handleZoomIn}
      handleZoomOut={handleZoomOut}
      showOriginalToolbar={showOriginalToolbar}
      toggleOriginalToolbar={() => setShowOriginalToolbar(prev => !prev)}
    />
    )}
    <div className={`door-container-left ${showTopBar ? '' : 'shift-down'} `}>
      {(showOriginalToolbar || !enableFloatingToolbarMenu) && <div className="toolbar-container">
          <div className="toolbar">
            <button
              className="toolbar-button"
              onClick={toggleViewDetails}
            >
              {isViewDetailsVisible ? "Hide Details" : "View Details"}
            </button>
            <button className="toolbar-button" onClick={togglePrices} disabled={!isViewDetailsVisible}>
              {displayPrices ? "Hide Prices" : "Show Prices"}
            </button>
            <button
              className={`toolbar-button ${isLoading ? "loading" : ""}`}
              onClick={handlePdfDownload}
              disabled={!isViewDetailsVisible || isLoading}
            >
              {isLoading ? (
                <span className="spinner"></span>
              ) : (
                "📄 PDF"
              )}
            </button>
            <button className={`toolbar-button`} onClick={() => handleSendEmail(true)} disabled={!isViewDetailsVisible}>
              ✉️ Email
            </button>
            <button className={`toolbar-button`} onClick={() => handleSaveQuote(false)}>
              💾 Save
            </button>
            <button className={`toolbar-button`} onClick={() => handleSaveQuote(true)}>
              ↩️ Exit
            </button>

            {/* ▼ Arrow toggle at the end */}
            <span
              className="arrow"
              onClick={() => setShowAltToolbar(prev => !prev)}
              title="Toggle more tools"
            >
              {showAltToolbar ? "▲" : "▼"}
            </span>
          </div>
          {showAltToolbar && (
          <div className="toolbar toolbar-secondary">
            <button className="toolbar-button" onClick={handleFlipToggle} >
              🧰 {flipped ? 'Show Front' : 'Show Back'}
            </button>
            {false && (
            <button className={`toolbar-button`} onClick={() => setIsDisabled(prev => !prev)}>
              {isDisabled ? "Enable Form" : "Disable Form"}
            </button>
            )}
             {false && (
            <button className="toolbar-button" onClick={() => alert("Alt Tool 2 clicked")}>
              🛠 Alt Tool 2
            </button>
            )}
            {false && (
            <button className="toolbar-button" onClick={() => alert("Alt Tool 3 clicked")}>
              ⚙️ Alt Tool 3
            </button>
            )}
            <button className="toolbar-button" onClick={handleZoomIn}>
              + Zoom In
            </button>
            <button className="toolbar-button" onClick={handleZoomOut}>
              − Zoom Out
            </button>
          </div>
          )}
      </div>}

      <div>
          {showTopBar && (enableFloatingToolbarMenu || enableFloatingNavMenu) ? (
            // Caption lives inside the sticky header so the docked bars never
            // cover it on scroll; the whole block stays pinned at the top.
            <div style={{ position: 'sticky', top: 0, zIndex: 1000, backgroundColor: tc.panelBg, paddingBottom: '6px' }}>
              <div className="door"><p><b><i>{doorData.frameData.name}</i></b></p></div>
              {enableFloatingToolbarMenu && (
                <TopBarToolbarMenu
                  isViewDetailsVisible={isViewDetailsVisible}
                  toggleViewDetails={toggleViewDetails}
                  displayPrices={displayPrices}
                  togglePrices={togglePrices}
                  isLoading={isLoading}
                  handlePdfDownload={handlePdfDownload}
                  handleSendEmail={handleSendEmail}
                  handleSaveQuote={handleSaveQuote}
                  flipped={flipped}
                  handleFlipToggle={handleFlipToggle}
                  handleZoomIn={handleZoomIn}
                  handleZoomOut={handleZoomOut}
                />
              )}
              {enableFloatingNavMenu && (
                <TopBarNavMenu
                  selectedSectionId={selectedSectionId}
                  showOnlySelected={showOnlySelectedSection}
                  disabledSections={disabledSections}
                  onSelectSection={(id) => {
                    setShowOnlySelectedSection(true);
                    setSelectedSectionId(id);
                    setExpandedSections(prev => ({ ...prev, [id]: true }));
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  onViewAll={() => {
                    setShowOnlySelectedSection(false);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                />
              )}
            </div>
          ) : (
            <div>
              <div className="door"><p><b><i>{doorData.frameData.name}</i></b></p></div>
            </div>
          )}

      {isSectionVisible('Configuration') && (
      <ExpandableSection
        title="🛠️ Window Configuration"
        panelLocation="2"
        controlMap={controlMap.filter((control) => control.expandableSectionId === "Configuration")}
        state="true"
        sectionId="Configuration"
        onExpandChange={handleSectionExpandChange}
        forceExpanded={getForceExpanded('Configuration')}
      >
      </ExpandableSection>
      )}

      {topRowConfValue !== 'None' && isSectionVisible('SizingAndFrameTop') && (
      <ExpandableSection
        title={sectionTopRowTitle}
        panelLocation="5"
        controlMap={controlMap.filter((control) => control.expandableSectionId === "SizingAndFrameTop")}
        sectionId="SizingAndFrameTop"
        onExpandChange={handleSectionExpandChange}
        forceExpanded={getForceExpanded('SizingAndFrameTop')}
      />
      )}
      {     (topRowConfValue === "1" || topRowConfValue === 'Grid')  &&
            (
            (windowTypeTopValue1 !== "None" && mainRowConfValue >= 1) ||
            (windowTypeTopValue2 !== "None" && mainRowConfValue >= 2) ||
            (windowTypeTopValue3 !== "None" && mainRowConfValue >= 3) ||
            (windowTypeTopValue4 !== "None" && mainRowConfValue >= 4) ||
            (windowTypeTopValue5 !== "None" && mainRowConfValue >= 5)) && isSectionVisible('GrillsTop') && (
        <ExpandableSection
          title="▦ Grills - Top Row"
          panelLocation="5"
          controlMap={controlMap.filter((control) => control.expandableSectionId === "GrillsTop")}
          sectionId="GrillsTop"
          onExpandChange={handleSectionExpandChange}
          forceExpanded={getForceExpanded('GrillsTop')}
        />
      )}
      {isSectionVisible('SizingAndFrame') && (
      <ExpandableSection
        title="🪟 Sizing & Frame - Main Row"
        panelLocation="2"
        controlMap={controlMap.filter((control) => control.expandableSectionId === "SizingAndFrame")}
        state1="true"
        sectionId="SizingAndFrame"
        onExpandChange={handleSectionExpandChange}
        forceExpanded={getForceExpanded('SizingAndFrame')}
      >
      </ExpandableSection>
      )}
    { (   /*(archGrillTypeValue1.value !== "None") ||*/
          (windowTypeValue1 !== "None" && mainRowConfValue >= 1 ) ||
          (windowTypeValue2 !== "None" && mainRowConfValue >= 2 ) ||
          (windowTypeValue3 !== "None" && mainRowConfValue >= 3 ) ||
          (windowTypeValue4 !== "None" && mainRowConfValue >= 4 ) ||
          (windowTypeValue5 !== "None" && mainRowConfValue >= 5 )) && isSectionVisible('Grills') && (
      <ExpandableSection
        title="▦ Grills - Main Row"
        panelLocation="5"
        controlMap={controlMap.filter((control) => control.expandableSectionId === "Grills")}
        sectionId="Grills"
        onExpandChange={handleSectionExpandChange}
        forceExpanded={getForceExpanded('Grills')}
      />
    )}
    { (true || /*archGrillTypeValue1 !== "None") ||*/
          (windowTypeValue1 !== "None") ||
          (windowTypeValue2 !== "None") ||
          (windowTypeValue3 !== "None") ||
          (windowTypeValue4 !== "None") ||
          (windowTypeValue5 !== "None")) && isSectionVisible('Glass') && (
      <ExpandableSection
        title="🔲 Glass"
        panelLocation="5"
        controlMap={controlMap.filter((control) => control.expandableSectionId === "Glass")}
        sectionId="Glass"
        onExpandChange={handleSectionExpandChange}
        forceExpanded={getForceExpanded('Glass')}
      />
    )}
      {isSectionVisible('Finish') && (
      <ExpandableSection
        title="🎨 Finish"
        panelLocation="5"
        controlMap={controlMap.filter((control) => control.expandableSectionId === "Finish")}
        sectionId="Finish"
        onExpandChange={handleSectionExpandChange}
        forceExpanded={getForceExpanded('Finish')}
      />
      )}

      {isSectionVisible('AdditionalItems') && (
      <ExpandableSection
        title="➕ Additional Items"
        panelLocation="6"
        controlMap={controlMap.filter((control) => control.expandableSectionId === "AdditionalItems")}
        sectionId="AdditionalItems"
        onExpandChange={handleSectionExpandChange}
        forceExpanded={getForceExpanded('AdditionalItems')}
      />
      )}

      {isSectionVisible('Installation') && (
      <ExpandableSection
        title="🔧 Installation"
        panelLocation="6"
        controlMap={controlMap.filter((control) => control.expandableSectionId === "Installation")}
        sectionId="Installation"
        onExpandChange={handleSectionExpandChange}
        forceExpanded={getForceExpanded('Installation')}
      />
      )}

      {isSectionVisible('Notes') && (
      <ExpandableSection
        title="📝 Notes"
        panelLocation="7"
        controlMap={controlMap.filter((control) => control.expandableSectionId === "Notes")}
        sectionId="Notes"
        onExpandChange={handleSectionExpandChange}
        forceExpanded={getForceExpanded('Notes')}
        state1="true"
      >
      </ExpandableSection>
      )}

      {isSectionVisible('Discounts') && (
      <ExpandableSection
        title="🏷️ Quantity"
        title1="💲 Discounts"
        panelLocation="8"
        controlMap={controlMap.filter((control) => control.expandableSectionId === "Discounts")}
        sectionId="Discounts"
        onExpandChange={handleSectionExpandChange}
        forceExpanded={getForceExpanded('Discounts')}
      />
      )}
      </div>
    </div>

    <div
          className={
            `door-container ${showTopBar ? '' : 'shift-down'} image-container1 ` +
            (isViewDetailsVisible ? "hidden-left-panel" : "")
          }
        >
        <div className="fixed-container_new">
          <p>&nbsp;&nbsp; {/*JSON.stringify(doorDataCopy2, null, 2)*/}
            <span style={{ fontSize: '12px' }}>{/*Zoom: {(zoom * 100).toFixed(0)}%*/}</span>
          </p>
          


              <div className={`svg-flip-container ${flipped ? 'flipped' : ''}`}
                style1={{
                  width: (doorData.frameData.mainRowWidth_d + INITX) * SCALE * zoom + 20,
                  height: (doorData.frameData.mainRowHeight_d + INITY) * SCALE * zoom + 20,
                }}
              >
                <DrawWindow doorData={doorDataCopy2} toLeft={ isViewDetailsVisible ? 40 - moreOffsetX : moreOffsetX} zoom={zoom} flip={flipped}/>
              </div>

      </div>
    </div>

      <ViewDetails
        isVisible={isViewDetailsVisible}
        data={viewDetailsData}
        doorData={doorDataCopy}
        updateCalcData={updateCalcData} // Pass the callback
        zoom={zoom} // Pass zoom for dynamic offset calculation
        onPriceInvisible={handleZoomOut} // [VP-AUTOFIT 2026-05-27] ww.js only: auto Zoom Out until the price-table reaches MIN_TABLE_PCT of panel width
        drawing={
          <div className={`svg-flip-container ${flipped ? 'flipped' : ''}`}  style={{ display: 'inline-block', border: '0px solid blue'}}>
            <DrawWindow doorData={doorDataCopy2} toLeft={ isViewDetailsVisible ? 40-moreOffsetX : 0} zoom={zoom}/>
          </div>
        }
      />
    {/*
            drawing={
          <MagicGlass width={600} height={400}>
            <DrawWindow doorData={doorDataCopy2} />
          </MagicGlass>
        } 
    */}  
    {/* end of View Details Sliding Window */}
    {showEmailDialog && (
        <EmailDialog
              isOpen={showEmailDialog}
              onClose={() => setShowEmailDialog(false)}
              isSending={isSending}
              setIsSending={setIsSending}
              customerEmail={customerEmail}
              /*container=".view-details"         // optional, default is ".view-details"
              filename="Quote"                  // optional
              subject="Your Quote PDF"          // optional
              message="Hello ,Please find your quote PDF attached." // optional*/
            />
    )}   
    </div>
);

};

export default WW;
